export default {
  translation: {
    commonUsedWords: {
      login: 'Iniciar sesión',
      email: 'Dirección de correo electrónico',
      password: 'Contraseña',
      emailIsRequired: 'Se requiere correo electrónico',
      mustBeAValidEmail: 'Debe ser un correo electrónico válido',
      deviceSerialNumber: 'Número de serie del dispositivo',
      next: 'Siguiente',
      back: 'Volver',
      success: 'Éxito',
      submit: 'Enviar',
      firstName: 'Nombre',
      firstNameIsRequired: 'Se requiere nombre',
      lastName: 'Apellido',
      lastNameIsRequired: 'Se requiere apellido',
      save: 'Guardar',
      delete: 'Eliminar',
      undoChanges: 'Deshacer cambios',
      cancel: 'Cancelar',
      loading: 'Cargando...',
      yes: 'Sí',
      no: 'No',
      clear: 'Limpiar',
      confirm: 'Confirmar',
      noOption: 'Sin opciones',
      noCompressorTemplatesFound: 'No se encontraron plantillas de compresor',
      openText: 'Abrir',
      edit: 'Editar',
      logout: 'Cerrar sesión',
      latitude: 'Latitud',
      longitude: 'Longitud',
      ok: 'Vale',
      okay: 'Está bien',
      done: 'Hecho',
      comingSoon: 'Próximamente...',
      reset: 'Restablecer',
      attention: 'Atención',
      note: 'Nota',
      continue: 'Continuar',
      finish: 'Finalizar',
      required: 'Este campo es obligatorio',
      close: 'Cerrar',
      copiedToClipboard: 'Copiado al portapapeles',
      apply: 'Aplicar',
    },
    api: {
      auth: {
        fieldsAreMissing: 'Faltan campos obligatorios',
        userNotFound: 'Usuario no encontrado',
        missingRefreshToken: 'Falta el token de actualización',
        cannotRefreshToken: 'No se puede actualizar el token',
      },
      helpers: {
        error: 'Error',
        invalidHTTPMethod: 'Método HTTP no válido',
      },
    },
    components: {
      autocompleteField: {
        presets: 'Predefinidos',
        results: 'Resultados',
      },
      dateRangePicker: {
        changeDates: 'Cambiar fechas',
        selectDateRange: 'Seleccione un rango de fechas',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha de fin',
        datePresets: {
          label: 'Preselecciones de fecha',
          today: 'Hoy',
          yesterday: 'Ayer',
          last7Days: 'Últimos 7 días',
          last30Days: 'Últimos 30 días',
          thisWeek: 'Esta semana',
          lastWeek: 'Semana pasada',
          thisMonth: 'Este mes',
          lastMonth: 'Mes pasado',
          thisYear: 'Este año',
          lastYear: 'Año pasado',
          allTime: 'Todo el tiempo',
        },
        calendar: {
          weekDays: {
            mon: 'Lu',
            tue: 'Ma',
            wed: 'Mi',
            thu: 'Ju',
            fri: 'Vi',
            sat: 'Sá',
            sun: 'Do',
          },
          months: {
            january: 'Enero',
            february: 'Febrero',
            march: 'Marzo',
            april: 'Abril',
            may: 'Mayo',
            june: 'Junio',
            july: 'Julio',
            august: 'Agosto',
            september: 'Septiembre',
            october: 'Octubre',
            november: 'Noviembre',
            december: 'Diciembre',
          },
        },
      },
      confirmEmail: {
        confirmEmail: 'Confirmar dirección de correo electrónico',
        confirmEmailIsRequired: 'Se requiere confirmar el correo electrónico',
        emailNotMatched: 'Las entradas de correo electrónico no coinciden',
      },
      confirmPassword: {
        confirmPassword: 'Confirmar contraseña',
        confirmPasswordIsRequired: 'Se requiere confirmar la contraseña',
        newPasswordIsRequired: 'Se requiere una contraseña nueva',
        showPassword: 'Mostrar contraseña',
        passwordLength: 'Las contraseñas deben tener al menos 6 caracteres',
        passwordContainSpaces: 'La contraseña no debe contener espacios',
        passwordNotMatch: 'Las entradas de contraseña no coinciden',
        newPassword: 'Nueva contraseña',
      },
      confirmModal: {
        areYouSure: '¿Estás seguro?',
      },
      appliedFilters: {
        between: 'Entre {{firstValue}} y {{secondValue}}',
        bottom: 'Inferior {{primaryValue}}%',
        top: 'Superior {{primaryValue}}%',
        activeFilters: 'Filtros activos',
        active: 'activo',
        closed: 'cerrado',
      },
      editTable: {
        editTable: 'Editar tabla',
        selectDeselect: 'Seleccionar/Deseleccionar valores de la tabla',
        resetToDefault: 'Restablecer a los valores predeterminados',
      },
      errorBoundary: {
        oops: '¡Vaya! Algo inesperado ocurrió.',
        tryAgain: '¡Inténtalo de nuevo! Si el problema persiste, comuníquese con su administrador.',
        refresh: 'Actualizar',
      },
      noResultFound: {
        noResultFoundTryAgain: 'Lo siento, no se encontraron resultados. Por favor, inténtelo de nuevo.',
      },
      permissionGuard: {
        invalidPermission: 'Estructura de permisos no válida, se esperan 3 elementos en la matriz',
      },
      preview: {
        findInView: 'Buscar en vista',
        showDetails: 'Mostrar detalles',
        closeEsc: 'Cerrar (Esc)',
        prevLeftArrow: 'Anterior (Flecha izquierda)',
        nextRightArrow: 'Siguiente (Flecha derecha)',
        proceedWithoutSaving: 'Navegar sin guardar',
        continueEditing: 'Continuar editando',
        unsavedChanges: {
          partTwo: 'Tienes ',
          partThree: 'CAMBIOS NO GUARDADOS',
          partFour: '. Navegar sin guardar descartará todos los cambios. ¿Estás seguro?',
        },
      },
      printRecord: {
        title: 'Registro',
        date: 'Fecha:',
        location: 'Ubicación',
        leakDetails: 'Detalles',
        leakParameters: 'Parámetros',
        energyLoss: 'Pérdida de energía',
        leakSourceEquipment: 'Equipo fuente',
        notes: 'Notas',
        leakEventStatus: 'Estado',
        requiredAction: 'Acción requerida',
        leakSourceImage: 'Imagen fuente',
        sourceImages: 'Imágenes de origen',
        additionalImages: 'Imágenes adicionales',
        additionalImage: 'Imagen adicional',
        smartLeakTag: 'Etiqueta inteligente',
        workRef: 'Referencia de trabajo',
        lossPerYear: 'Pérdida ({{currency}}/año)',
        costOfEnergy: 'Costo de la energía ({{currency}}/kWh)',
      },
      assignedAction: {
        actionHeader: {
          deleteAssignmentSuccess: 'La asignación ha sido eliminada',
          deleteAssignmentError: 'La asignación no se puede eliminar. Por favor, inténtelo de nuevo más tarde',
          currentlyAssigned: 'Acción asignada actualmente',
          repairedBy: 'Reparado por',
          text: 'Vas a eliminar esta asignación. Esta acción no se puede deshacer',
        },
        actionSaveDate: 'Última guardado',
      },
      visibleColumnsPopper: {
        tableValues: 'Seleccionar / Deseleccionar valores de la tabla',
      },
      tableHead: {
        deselectCurrentPage: 'Deseleccionar página actual',
        selectCurrentPage: 'Seleccionar página actual',
      },
      coverPage: {
        title: 'Informe de Registros',
        reportDate: 'Fecha del informe: {{date}}',
        poweredBy: 'Desarrollado por {{companyName}}',
        date: 'Rango de fechas: {{from}} - {{to}}',
        includedRecords: 'Registros incluidos: {{count}}',
        totalLoss: 'Pérdida total',
        lossByCurrency: '{{currency}}: {{loss}}',
        totalKwhLoss: 'Pérdida total de kWh: {{kwh}} kWh/año',
      },
      tagsCoverPage: {
        title: 'Informe de Smart Tags',
        reportDate: 'Fecha del informe: {{date}}',
        poweredBy: 'Desarrollado por {{companyName}}',
        date: 'Rango de fechas: {{from}} - {{to}}',
        includedTags: 'Smart Tags incluidos: {{count}}',
        includedRecords: 'Registros incluidos: {{count}}',
        totalKwhLoss: 'Pérdida total de kWh: {{kwh}} kWh/año',
      },
      EnergyEfficiencyGauge: {
        title: 'Calificación de eficiencia energética',
        recommendedRange: 'Rango de eficiencia recomendado',
        levels: {
          good: {
            label: 'Buena',
            description:
              'Su sistema funciona cerca de su potencial ideal y más eficiente. Compresor moderno y de alta eficiencia (p. ej., accionamiento de velocidad variable o tornillo rotativo totalmente cargado en el punto de diseño)',
          },
          average: {
            label: 'Media',
            description:
              'Su sistema presenta ineficiencias típicas; hay margen de mejora. Sistema industrial típico, posiblemente con equipos más antiguos o funcionando en gran medida a carga parcial con controles menos eficientes (p. ej., carga/descarga)',
          },
          poor: {
            label: 'Deficiente',
            description:
              'Su sistema es muy ineficiente (probablemente debido a fugas, equipos antiguos o electricidad de alto costo) y requiere atención inmediata. Sistema antiguo y mal mantenido, o que opera con una ineficiencia extrema a carga parcial (p. ej., varios compresores funcionando de manera no optimizada)',
          },
        },
      },
    },
    constants: {
      qualifiers: {
        EQUAL_TO: 'Igual a',
        LESS_THAN: 'Menos que',
        GREATER_THAN: 'Mayor que',
        LESS_THAN_OR_EQUAL_TO: 'Menor o igual a',
        GREATER_THAN_OR_EQUAL_TO: 'Mayor o igual a',
        BETWEEN_A_AND_Y: 'Entre',
        TOP_PERCENT: 'Superior "x"%',
        BOTTOM_PERCENT: 'Inferior "x"%',
      },
      recordFields: {
        CREATED_AT: 'Fecha de creación',
        RECORD_ID: 'Número de registro',
        DOCUMENT_ID: 'Número de registro',
        DOLLARS_PER_YEAR: 'Pérdida',
        GAS_COMPONENT: 'Gas/Componente',
        LEAK_TYPE: 'Perfil de fuga',
        DATE_TIME: 'Fecha/Hora de creación',
        DB_PEAK: 'Pico dB',
        COMPANY: 'Compañía',
        NOTES: 'Notas',
        USER: 'Usuario',
        EQUIPMENT_TAG: 'Etiqueta de equipo/Componente',
        FLOW: 'Flujo (m³/h)',
        EQUIPMENT: 'Unidad/Edificio/Máquina',
        ROUTE: 'Ruta',
        ROUTE_LOCATION: 'Ubicación de la ruta',
        ROUTE_EQUIPMENT_NAME: 'Equipo de Ruta',
        PROJECT_SURVEY: 'Referencia de la auditoría/encuesta',
        OUTAGE_STATUS: '¿Requiere apagado/cierre?',
        FACILITY: 'Instalación/Sitio',
        ACTION_STATUS: 'Estado de la acción',
        SERVICE_TYPE: 'Servicio/Tipo',
        DB_ACTIVE: 'dB Activo',
        REFERENCE_ID: 'Referencia del proyecto/ID de la encuesta',
        AMBIENT_TEMPERATURE: 'Temperatura ambiental (°C)',
        LEAK_PRESSURE: 'Presión (kPag)',
        LEAK_TEMPERATURE: 'Temperatura del gas (°C)',
        LEAK_CATEGORY: 'Categoría',
        DISTANCE: 'Distancia (m)',
        GAS_COST: 'Costo del gas ($/m³)',
        COMPRESSOR_FLOW: 'm³/h por BHP',
        DEVICE_ID: 'ID del dispositivo',
        COMPRESSOR_BHP: 'BHP del compresor',
        COMPRESSOR_TYPE: 'Tipo de compresor',
        MOTOR_EFFICIENCY: 'Eficiencia del motor (%)',
        ENERGY_COST: 'Costo de energía ($/kWh)',
        HOURS: 'Horas de funcionamiento/año',
        LOCATION: 'Ubicación',
        LAST_MODIFIED: 'Fecha/Hora de último guardado',
        POWER_LOAD: '% Carga completa',
        CLIENT: 'Cliente',
        SERVICE: 'Servicio',
        CAPACITY: '% Capacidad',
        EQUIPMENT_TYPE: 'Tipo de equipo/Componente',
        SMART_TAG: 'Etiqueta inteligente n.º',
        WORK_REF: 'Referencia de trabajo n.º',
        REPAIRED_BY: 'Reparado por',
        ALTITUDE: 'Altitud (m)',
        REQUIRED_ACTION: 'Acción requerida',
        FREQUENCY_LOW_BOUND: 'Frecuencia (baja)',
        FREQUENCY_HIGH_BOUND: 'Frecuencia (alta)',
        SENSITIVITY: 'Sensibilidad',
        KWH_PER_YEAR: 'kWh/año',
        ASSIGNED_BY: 'Asignado por',
        ASSIGNED_TO: 'Asignado a',
        ASSIGNED_DATE: 'Fecha de asignación',
        LOSS_PER_YEAR: 'Pérdida (por año)',
        ASSIGNED: 'Asignado',
        CREATOR_USER_ID: 'ID de usuario',
        CURRENCY: 'Moneda',
        COMPLETED_ON: 'Completado el',
        IMAGES: 'Imágenes de origen',
        ACTION_STATUS_MODIFIED: 'Estado de la acción modificado',
        TYPE: 'Tipo',
      },
      electricalRecordFields: {
        REGION: 'Región',
        LOCATION_TYPE: 'Tipo de Ubicación',
        VOLTAGE: 'Voltaje',
        PHASE: 'Fase',
        FREQUENCY: 'Frecuencia',
        ELECTRICAL_EQUIPMENT_TAG: 'Equipo/Componente',
        ELECTRICAL_EQUIPMENT_TYPE: 'Tipo de Equipo/Componente',
        FAULT_TYPE: 'Tipo de Falla',
        ELECTRICAL_NOTES: 'Notas',
      },
      IMPERIAL_LABELS: {
        FLOW: 'Flujo (cfm)',
        AMBIENT_TEMPERATURE: 'Temperatura ambiente (°F)',
        LEAK_PRESSURE: 'Presión (psi)',
        LEAK_TEMPERATURE: 'Temperatura del gas (°F)',
        DISTANCE: 'Distancia (ft)',
        GAS_COST: 'Costo del gas ($/ft³)',
        COMPRESSOR_FLOW: 'cfm por BHP',
        ALTITUDE: 'Altitud (ft)',
      },
      userFields: {
        EMAIL: 'Correo electrónico',
        ROLE: 'Rol',
        DEVICE_ID: 'ID del dispositivo',
        SUBSCRIPTION_RENEWAL_DATE: 'Fecha de renovación de la suscripción',
        DATE_TIME: 'Creado',
        ACTIVE: 'Estado',
        SOFTWARE_VERSION: 'Versión del software',
        FIRMWARE_VERSION: 'Versión del firmware',
        FIRST_NAME: 'Nombre',
        LAST_NAME: 'Apellido',
        COMPANY_SLUG: 'Empresa',
        COMPANY_NAME: 'Empresa',
      },
      auditFields: {
        documentId: 'Número de ID de registro',
        companyName: 'Nombre de la empresa',
        auditorName: 'Nombre del auditor',
        auditorEmail: 'Correo electrónico del auditor',
        createdAt: 'Creado el',
        updatedAt: 'Actualizado el',
        comment: 'Comentarios',
        isLocked: 'Bloqueo de auditoría',
      },
      deviceFields: {
        DEVICE_ID: 'ID del dispositivo',
        ACTIVE: 'Estado',
        REGISTERED_ON: 'Activado el',
        EVENT_COUNT: 'Registros',
        UNIQUE_COMPANIES: 'Empresas',
        LAST_USED_AT: 'Última utilización el',
        LAST_USED_BY_NAME: 'Último nombre usado',
        LAST_USED_BY_EMAIL: 'Último correo electrónico usado',
        LOCATION: 'Última ubicación usada',
        FIRMWARE_VERSION: 'Versión del firmware',
      },
      statsFields: {
        labels: {
          TIMELINE: 'Cronología',
          CRITERIA: 'Criterios',
        },
        timeline: {
          LAST_3_MONTHS: 'Últimos 3 meses',
          LAST_6_MONTHS: 'Últimos 6 meses',
          LAST_12_MONTHS: 'Últimos 12 meses',
          YEAR_TO_DATE: 'Año hasta la fecha',
          ALL_TIME: 'Todo el tiempo',
        },
        criteria: {
          LOSS: 'Pérdida',
          FLOW: 'Flujo',
          KWH: 'kWh',
        },
      },
      enpisFields: {
        labels: {
          NO_OF_LEAKS_FOUND: 'Número de fugas encontradas',
          NO_OF_LEAKS_REPAIRED: 'Número de fugas reparadas',
          PERCENT_LEAKS_REPAIRED: '% Fugas reparadas',
          VOL_FLOW_FOUND: 'Flujo de volumen encontrado (m³/h)',
          VOL_FLOW_REPAIRED: 'Flujo de volumen reparado (m³/h)',
          PERCENT_VOL_FLOW_REPAIRED: '% Flujo reparado',
          VALUE_FOUND: 'Valor encontrado',
          VALUE_REPAIRED: 'Valor reparado',
          ENERGY_SAVING_OPPORTUNITY_FOUND: 'Oportunidad de ahorro energético (encontrado) (kWh)',
          ENERGY_SAVING_OPPORTUNITY_PERCENT: 'Oportunidad de ahorro energético % (encontrado vs calculado o medido)',
          ENERGY_SAVING_REALIZED_FIXED: 'Ahorro energético realizado (reparado) (kWh)',
          ENERGY_SAVING_REALIZED_PERCENT: '% Ahorro energético realizado (reparado vs calculado o medido)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Presión de control del sistema reducida (kPag)',
        },
        labelsImperial: {
          VOL_FLOW_FOUND: 'Flujo de volumen encontrado (cfm)',
          VOL_FLOW_REPAIRED: 'Flujo de volumen reparado (cfm)',
          ENERGY_SAVING_OPPORTUNITY_FOUND: 'Oportunidad de ahorro energético (encontrado) (BTU)',
          ENERGY_SAVING_REALIZED_FIXED: 'Ahorro energético realizado (reparado) (BTU)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Presión de control del sistema reducida (psi)',
        },
        columns: {
          PERFORMANCE_INDICATOR: 'Indicador de rendimiento',
          ENPI_VALUE: 'Valor EnPI',
          ENB_VALUE: 'Valor EnB',
          SUCCESS_THRESHOLD: 'Umbral de éxito (%)',
        },
      },
      companiesFields: {
        labels: {
          NAME: 'Nombre de la empresa',
          COUNTRY_ID: 'País',
          CURRENCY: 'Moneda',
          LANGUAGE: 'Idioma',
          INDUSTRY: 'Industria',
        },
      },
      assignedAction: {
        assignedTo: 'Asignado a',
        assignedBy: 'Asignado por',
        assignedDate: 'Fecha de asignación',
        requestReassign: 'Solicitar reasignación',
        actionStatus: 'Estado de la acción',
        partsNeeded: 'Parte requerida',
        productionOutage: 'Solicitud de apagado',
        timeToRepair: 'Tiempo de reparación',
        repairCost: 'Costo de reparación',
        closeOutRef: 'Ref. de cierre',
        'assignmentRecord.documentId': 'ID de registro',
        assignmentId: 'ID de asignación',
        owner: 'Propietario',
        companyName: 'Empresa',
        assignmentActive: 'Estado de la asignación',
        'assignmentRecord.leakStatus.building': 'Unidad/Edificio/Máquina',
        'assignmentRecord.leakStatus.facility': 'Instalación',
        'assignmentRecord.leakStatus.routeName': 'Ruta',
        'assignmentRecord.leakStatus.smartTag': 'Etiqueta inteligente #',
        'assignmentRecord.leakStatus.workRef': 'Referencia de trabajo #',
        'assignmentRecord.currency': 'Moneda',
      },
      AAR_FIELD_LABEL: {
        NOTES: 'Acción tomada',
        CLOSE_OUT_REF: 'Referencia de cierre de acción n.º',
        PARTS_NEEDED: 'Nueva pieza/componente requerido',
        PRODUCTION_OUTAGE: 'Producción interrumpida',
        REPAIR_COST: 'Costo ($)',
        REQUEST_REASSIGN: 'Solicitar reasignación',
        ACTION_STATUS: 'Estado de la acción',
        TIME_TO_REPAIR: 'Tiempo de reparación (minutos)',
      },
      leak: {
        chartsLabels: {
          FLOW_BY_LEAK: 'Flujo por categoría de fuga',
          LOSS_BY_LEAK: 'Pérdida por categoría de fuga',
          TAGS_BY_LEAK: 'Etiquetas por categoría de fuga',
          AVG_FLOW_BY_LEAK: 'Flujo promedio por categoría de fuga',
          SAVING_OPT_BY_REPAIR: 'Oportunidad y ahorros por tiempo de reparación',
          FLOW_REPAIR_TIME: 'Flujo por tiempo de reparación',
          LOSS_REPAIR_TIME: 'Pérdida por tiempo de reparación',
          FLOW_REPAIR_PROG: 'Flujo por progreso de reparación',
          TOTAL_REPAIR_PROG: 'Pérdida por progreso de reparación',
          FLOW_BY_EQUIP_COMP: 'Flujo por equipo/componente',
          LOSS_BY_EQUIP_COMP: 'Pérdida por equipo/componente',
          TAGS_BY_EQUIP_COMP: 'Etiquetas por equipo/componente',
        },
        leakCategoryLabels: {
          LOW: 'Bajo',
          MEDIUM: 'Medio',
          HIGH: 'Alto',
        },
        actionStatus: {
          OPEN: 'Abrir',
          COMPLETE: 'Completo',
        },
        equipmentTypes: {
          CONNECTOR: 'Conector',
          CONTROL_VALVE: 'Válvula de control',
          HOSE: 'Manguera',
          TUBE_FITTING: 'Conector de tubo',
          METER: 'Medidor',
          OPEN_ENDED_LINE: 'Línea abierta',
          PRESSURE_RELIEF_VALVE: 'Válvula de alivio de presión',
          PUMP_SEAL: 'Sello de bomba',
          REGULATOR: 'Regulador',
          VALVE: 'Válvula',
          LEVEL_CONTROLLER: 'Controlador de nivel',
          POSITIONER: 'Posicionador',
          PRESSURE_CONTROLLER: 'Controlador de presión',
          TRANSDUCER: 'Transductor',
          GENERIC_PNEUMATIC_INSTRUMENT: 'Instrumento neumático genérico',
          GENERIC_RECIPROCATING_COMPRESSOR: 'Compresor alternativo genérico',
          GENERIC_CENTRIFUGAL_COMPRESSOR: 'Compresor centrífugo genérico',
        },
        mainGasValues: {
          AIR: 'Aire',
          METHANE: 'Metano (CH4)',
          CARBON_DIOXIDE: 'Dióxido de carbono (CO2)',
          HYDROGEN: 'Hidrógeno (H2)',
          HELIUM: 'Helio (He)',
          NITROGEN: 'Nitrógeno (N2)',
          REFRIGERANT: 'Refrigerante (HFCs)',
          ARGON: 'Argón (Ar)',
          OXYGEN: 'Oxígeno (O)',
          WATER: 'Agua (Vapor)',
        },
        leakTypeValues: {
          DEFAULT: 'Ninguno seleccionado',
          HOLE: 'Agujero',
          CRACK: 'Grieta',
          FITTING: 'Conector',
          FLANGE: 'Brida',
          'GLAND/SEAL': 'Gland/Seal', // Not fully translated
          THREAD: 'Rosca',
          'TUBE/HOSE': 'Tubo/Manguera',
        },
        serviceValues: {
          COMPRESSED_AIR: 'Aire comprimido',
          VACUUM: 'Vacío',
          STEAM: 'Vapor',
          PROCESS_GAS: 'Gas de proceso',
          LIQUID: 'Líquido',
        },
        compressorTypesValues: {
          ROTARY_SCREW: 'Tornillo rotativo',
          RECIPROCATING: 'Alternativo',
          SCROLL: 'Scroll',
          CENTRIFUGAL: 'Centrífugo',
        },
        regionValues: {
          NORTH_AMERICA: 'América del Norte',
          OUTSIDE_NORTH_AMERICA: 'Fuera de América del Norte',
        },
        locationTypeValues: {
          RESIDENTIAL: 'Residencial',
          COMMERCIAL: 'Comercial',
          INDUSTRIAL: 'Industrial',
          MEDIUM_VOLTAGE: 'Media Tensión',
          HIGH_VOLTAGE: 'Alta Tensión',
        },
        phaseValues: {
          SINGLE_PHASE: 'Monofásico',
          THREE_PHASE: 'Trifásico',
        },
        faultValues: {
          SELECT_FAULT_TYPE: 'Seleccione el tipo de falla',
          KNICKS_OR_VOIDS_IN_INSULATION: 'Muescas o huecos en el aislamiento',
          CORONA: 'Corona',
          TREEING: 'Formación de árboles',
          TRACKING: 'Seguimiento',
          ARCING: 'Arco eléctrico',
          'DIRTY_POWER/POWER_DISTORTION': 'Potencia sucia/distorsión',
          MECHANICAL_LOOSENESS: 'Holgura mecánica',
          DELAMINATION_OF_WINDINGS: 'Delaminación de los devanados',
          LOOSE_PANEL: 'Panel suelto',
          VIBRATING_NAMEPLATE: 'Placa vibratoria',
          ANTAGONISTIC_ULTRASOUND: 'Ultrasonido antagonista',
          OTHER: 'Otro',
        },
        electricEquipmentTypeValues: {
          MCC: 'MCC (Control de motores)',
          'TRANSFORMER,_DRY': 'Transformador, Seco',
          'TRANSFORMER,_OIL': 'Transformador, Aceite',
          SWITCH_GEAR: 'Equipos de conmutación',
          PANEL: 'Panel',
          BUSDUCT: 'Canalización de buses',
          CABLE: 'Cable',
          CONNECTOR: 'Conector',
          BREAKER: 'Interruptor',
          BUSHING: 'Aislante',
          TRANSMISSION_LINE: 'Línea de transmisión',
          'TRANSFORMER,_POLE': 'Transformador, Poste',
          BATTERY: 'Batería',
          BATTERY_BANK: 'Banco de baterías',
          TERMINALS: 'Terminales',
          'TRANSFORMER,_STEP_UP': 'Transformador, Elevador',
          'TRANSFORMER,_STEP_DOWN': 'Transformador, Reductor',
          DISTRIBUTION_PANEL: 'Panel de distribución',
          BREAKER_PANEL: 'Panel de disyuntores',
          RELAYS: 'Relés',
          CAPACITORS: 'Condensadores',
          REACTORS: 'Reactores',
          UPS: 'UPS',
          GROUNDING: 'Aterrizaje',
          POWER_METERS: 'Contadores de energía',
          CURRENT_TRANSFORMERS: 'Transformadores de corriente',
          POTENTIAL_TRANSFORMERS: 'Transformadores de potencial',
          SURGE_PROTECTION: 'Protección contra sobretensiones',
          CABLE_TRAYS: 'Canales para cables',
          EMERGENCY_LIGHTING: 'Iluminación de emergencia',
          CONTACTORS: 'Contactores',
          INVERTERS: 'Inversores',
          SOLAR_PANELS: 'Paneles solares',
          BATTERY_STORAGE_SYSTEMS: 'Sistemas de almacenamiento de baterías',
        },
        recordTypes: {
          leak: 'Fuga',
          electrical: 'Eléctrico',
        },
        labels: {
          LOW: 'Bajo',
          MEDIUM: 'Medio',
          HIGH: 'Alto',
          EQUIPMENT: 'Equipo',
          SAVINGS: 'Ahorros',
          OPPORTUNITY: 'Oportunidad',
          LOSS: 'Pérdida',
          REPAIRED: 'Reparado',
          UNREPAIRED: 'No reparado',
          LESS_15_DAYS: 'Menos de 15 días',
          DAYS_16_TO_30: '15 a 30 días',
          DAYS_31_TO_60: '31 a 60 días',
          DAYS_61_TO_90: 'Más de 60 días',
          LESS_THAN_15_DAYS: 'Reparado en menos de 15 días',
          '16_TO_30_DAYS': 'Reparado en 16-30 días',
          '31_TO_60_DAYS': 'Reparado en 31-60 días',
          MORE_THAN_60_DAYS: 'Reparado en 61-90 días',
          AIR: 'Aire',
          METHANE: 'Metano (CH4)',
          CARBON_DIOXIDE: 'Dióxido de carbono (CO2)',
          HYDROGEN: 'Hidrógeno (H2)',
          HELIUM: 'Helio (He)',
          NITROGEN: 'Nitrógeno (N2)',
          REFRIGERANT: 'Refrigerante (HFCs)',
          ARGON: 'Argón (Ar)',
          OXYGEN: 'Oxígeno (O)',
          WATER: 'Agua (Vapor)',
          DEFAULT: 'Ninguno seleccionado',
          HOLE: 'Agujero',
          CRACK: 'Grieta',
          FITTING: 'Conector',
          FLANGE: 'Brida',
          'GLAND/SEAL': 'Gland/Seal',
          THREAD: 'Rosca',
          'TUBE/HOSE': 'Tubo/Manguera',
          COMPRESSED_AIR: 'Aire comprimido',
          VACUUM: 'Vacío',
          STEAM: 'Vapor',
          PROCESS_GAS: 'Gas de proceso',
          LIQUID: 'Líquido',
          ROTARY_SCREW: 'Tornillo rotativo',
          RECIPROCATING: 'Alternativo',
          SCROLL: 'Scroll',
          CENTRIFUGAL: 'Centrífugo',
          CONNECTOR: 'Conector',
          CONTROL_VALVE: 'Válvula de control',
          HOSE: 'Manguera',
          TUBE_FITTING: 'Conector de tubo',
          METER: 'Medidor',
          OPEN_ENDED_LINE: 'Línea abierta',
          PRESSURE_RELIEF_VALVE: 'Válvula de alivio de presión',
          PUMP_SEAL: 'Sello de bomba',
          REGULATOR: 'Regulador',
          VALVE: 'Válvula',
          LEVEL_CONTROLLER: 'Controlador de nivel',
          POSITIONER: 'Posicionador',
          PRESSURE_CONTROLLER: 'Controlador de presión',
          TRANSDUCER: 'Transductor',
          GENERIC_PNEUMATIC_INSTRUMENT: 'Instrumento neumático genérico',
          GENERIC_RECIPROCATING_COMPRESSOR: 'Compresor alternativo genérico',
          GENERIC_CENTRIFUGAL_COMPRESSOR: 'Compresor centrífugo genérico',
        },
        leakRecordPDF: 'Registro • Exportado el {{date}}',
        leakTag: 'Etiquetas inteligentes • Exportadas el {{date}}',
      },
      compressorFields: {
        labels: {
          COMPRESSOR_TAG: 'Etiqueta del compresor',
          COMPRESSOR_MAKE: 'Marca del compresor',
          COMPRESSOR_MODEL: 'Modelo del compresor',
          COMPRESSOR_TYPE: 'Tipo de compresor',
          NAMEPLATE_HP: 'Potencia nominal (HP)',
          NAMEPLATE_CAPACITY: 'Capacidad nominal (m³/h)',
          MOTOR_EFFICIENCY: 'Eficiencia del motor (%)',
          MOTOR_VOLTAGE: 'Voltaje del motor',
          FULL_LOAD_CURRENT: 'Corriente a plena carga (Amperios)',
          FULL_LOAD_INPUT_POWER: 'Potencia de entrada a plena carga (kW)',
          RATED_PRESSURE: 'Presión nominal (kPag)',
          PRESSURE_SETPOINT: 'Punto de ajuste de presión (kPag)',
          CONTROL: 'Control',
          TOTAL_AIR_STORAGE_SIZE: 'Tamaño total de almacenamiento de aire (l)',
          IS_ACTIVE: 'Compresor activo / apagado',
          OPERATION_TYPE: 'Trim / Carga base',
          PERCENT_LOAD: '% Carga',
          COMPRESSOR_SETPOINT_SEU: 'Punto de ajuste del compresor (kPag)',
          COMPRESSOR_FLOW_SEU: 'Flujo del compresor (m³/h)',
          SYSTEM_PRESSURE_SETPOINT: 'Punto de ajuste de presión del sistema (kPag)',
          SYSTEM_MEASURED_FLOW: 'Flujo medido del sistema (m³/h)',
          DATE_TIME_RUNNING_STATE: 'Fecha y hora del estado de funcionamiento',
          NOTES: 'Notas',
          NAMEPLATE: 'Placa de identificación del compresor',
          DATASHEET: 'Hoja de datos del compresor',
          BHP: 'BHP',
          OPERATING_HOURS: 'Horas de operación',
          LOADED_PERCENT_TIME_RUNNING: '% Tiempo en funcionamiento',
          LOADED_PERCENT_FULL_LOAD_BHP: '% BHP a plena carga (Capacidad)',
          UNLOADED_PERCENT_TIME_RUNNING: '% Tiempo en funcionamiento',
          UNLOADED_PERCENT_FULL_LOAD_BHP: '% BHP a plena carga (Capacidad)',
          ENERGY_COST: 'Tarifa eléctrica agregada ($)',
          ANNUAL_ENERGY_COST: 'Costo anual de energía ($)',
          ANNUAL_ENERGY_KWH: 'Energía anual en kWh',
          COST_FULLY_LOADED: 'Costo cuando está completamente cargado ($)',
          COST_UNLOADED: 'Costo cuando está descargado ($)',
          KWH_PER_YEAR_LOADED: 'kWh por año cuando está cargado',
          KWH_PER_YEAR_UNLOADED: 'kWh por año cuando está descargado',
          ENERGY_COST_PER_UNIT: '$/m³',
        },
        labelsImperial: {
          NAMEPLATE_CAPACITY: 'Capacidad nominal (cfm)',
          FULL_LOAD_INPUT_POWER: 'Potencia de entrada a plena carga (BTU/h)',
          RATED_PRESSURE: 'Presión nominal (psi)',
          PRESSURE_SETPOINT: 'Punto de ajuste de presión (psi)',
          TOTAL_AIR_STORAGE_SIZE: 'Tamaño total de almacenamiento de aire (gal)',
          COMPRESSOR_SETPOINT_SEU: 'Punto de ajuste del compresor (psi)',
          COMPRESSOR_FLOW_SEU: 'Flujo del compresor (cfm)',
          SYSTEM_PRESSURE_SETPOINT: 'Punto de ajuste de presión del sistema (psi)',
          SYSTEM_MEASURED_FLOW: 'Flujo medido del sistema (cfm)',
          ENERGY_COST_PER_UNIT: '$/cf',
        },
      },
      energyFields: {
        labels: {
          UTILITY_PROVIDER: 'Proveedor de servicios',
          ENERGY_COST: '$/kWh',
          ENERGY_UNIT: 'Unidad',
          REBATE_COST: '$/kWh',
          REBATE_UNIT: 'Unidad',
          ENERGY_SOURCES: 'Fuentes de energía',
          FE_HOURS_OPERATION: 'Horas de operación',
          FE_ENERGY_COST: 'Costo de energía ($/kWh)',
          FE_EFFICIENCY: 'Eficiencia (kW/m³/h)',
          KWH_PER_FLOW: 'kWh/m³/h',
          COST_PER_FLOW: '$/m³',
        },
        labelsImperial: {
          FE_EFFICIENCY: 'Eficiencia (kW/cfm)',
          KWH_PER_FLOW: 'kWh/cfm',
          COST_PER_FLOW: '$/cf',
        },
      },
    },
    hooks: {
      useError: {
        message: 'Error de validación de la solicitud. Por favor, revise los campos del formulario',
      },
    },
    layouts: {
      dashboardLayout: {
        topBar: {
          registerADevice: 'Registrar un dispositivo',
          help: 'Ayuda',
          metric: 'Métrico',
          imperial: 'Imperial',
          downloadApk: 'Descargar APK',
          downloadOta: 'Descargar archivo',
        },
        otaDialog: {
          title: 'Descargar archivo',
          downloadButton: 'Descargar',
          serialNumberLabel: 'Número de serie del dispositivo',
          serialNumberRequired: 'Se requiere número de serie',
          fileDownloaded: 'Archivo {{fileName}} descargado con éxito',
          errorFetchingFile: 'Error al obtener el archivo. Por favor, inténtelo de nuevo más tarde',
          selectSerialNumber: 'Seleccione un número de serie de dispositivo',
        },
        banners: {
          leakRecordsList: {
            dialogOne: 'Estás en el plan Esencial.',
            dialogTwo: 'Haz clic ',
            dialogThree: 'aquí ',
            dialogFour: 'para comprar una nueva licencia de administrador o contacta con ',
            dialogFive: 'support@prosaris.ca',
          },
          serviceUnavailable:
            'Estamos experimentando dificultades técnicas. Nuestro servicio puede verse afectado. Disculpe las molestias.',
          downForMaintenance: 'Estamos realizando tareas de mantenimiento. Volveremos pronto.',
          tagsManagement: {
            question: '¿Disfrutas de tus PROSARIS Smart Tags?',
            purchaseLink: '¡Compra etiquetas inteligentes adicionales aquí!',
          },
        },
        mobileNav: {
          index: {
            menu: 'Menú',
            editProfile: 'Editar perfil',
            logout: 'Cerrar sesión',
          },
        },
        notifications: {
          title: 'Notifications',
          notificationsList: {
            clearAll: 'Borrar todo',
            readAll: 'Marcar todo como leído',
            noNotifications: 'No hay notificaciones',
          },
        },
        index: {
          dashboard: 'Tablero',
          records: 'Registros',
          actions: 'Acciones',
          company: 'Empresa',
          tags: 'Etiquetas',
          support: 'Support',
        },
        loggedInAs: 'Conectado como',
      },
    },
    utils: {
      displayAssignedRecords: {
        cannontDeterminByField: 'No se puede determinar la etiqueta por el campo {{field}}',
        cannontDeterminByLabel: 'No se puede determinar el campo por la etiqueta {{label}}',
        active: 'Activo',
        closed: 'Cerrado',
      },
    },
    views: {
      commonUsedWords: {
        dashboard: 'Tablero',
        records: 'Registros',
        actions: 'Acciones',
        company: 'Empresa',
        tags: 'Etiquetas',
        redirecting: 'Redirigiéndote...',
      },
      account: {
        index: {
          updatePassword: 'Contraseña actualizada con éxito.',
          accountDeletedSuccess: 'La cuenta {{user}} ha sido eliminada con éxito',
          accountDeletedError: 'No se puede eliminar la cuenta en este momento. Por favor, inténtelo de nuevo más tarde.',
          authenticationError: 'Error al autenticar al usuario',
          currentPasswordIsRequired: 'Se requiere la contraseña actual',
          firstNameIsRequired: 'El nombre es obligatorio',
          lastNameIsRequired: 'El apellido es obligatorio',
          personalDetails: 'Información básica',
          changePassword: 'Restablecer contraseña',
          currentPassword: 'Contraseña actual',
          profilePicture: 'Foto de perfil',
          dangerZone: 'Zona de peligro',
          integrations: 'Integraciones',
          sosShipments: 'SOS Inventario',
          sosSyncMessage:
            'Este proceso desencadena el procesamiento de pedidos SOS en Prosaris con los últimos datos de SOS Inventario. Aunque este proceso generalmente se gestiona automáticamente cada 4 horas a través de una tarea programada, usar este botón permite iniciar el proceso manualmente.',
          sosSyncSuccess: 'La sincronización de SOS se ha activado con éxito',
          triggerSosSync: 'Activar sincronización SOS',
          hubspot: 'HubSpot',
          hubspotSyncMessage:
            'Este proceso empuja instantáneamente los últimos datos de la plataforma a HubSpot. Esta sincronización ocurre automáticamente cada hora a través de una tarea programada, pero haciendo clic en el botón permite iniciar la sincronización manualmente cuando se necesite.',
          hubspotSyncSuccess: 'La sincronización de HubSpot se ha activado con éxito',
          triggerHubspotSync: 'Activar sincronización HubSpot',
          deleteAccountTitle: 'Eliminar cuenta',
          deleteAccountMessage: 'La cuenta ya no estará disponible y toda la información personal se eliminará permanentemente.',
          alertTitle: 'Por favor, confirme la eliminación de la cuenta',
          deleteDialog: {
            dialogTwo: 'Eliminar su cuenta eliminará permanentemente toda su información personal de nuestra base de datos.',
            dialogThree: 'ESTA ACCIÓN NO SE PUEDE DESHACER.',
            dialogFour: 'Por favor, introduzca su contraseña para continuar.',
          },
        },
        toolBar: {
          cacheClearedSuccess: '¡Caché borrado con éxito!',
          editProfile: 'Editar perfil',
          clearCache: 'Borrar caché',
          alertTitle: 'Por favor, confirme el borrado del caché de la aplicación',
          deleteAll: 'Eliminar todo',
          accordionDialog: {
            dialogOne: 'Esto eliminará todas las configuraciones almacenadas para las siguientes páginas:',
            dialogTwo: 'Gráficos, filtros de gráficos, marco de tiempo',
            dialogThree: 'Filtros, Ordenar, Columnas, Vista previa',
            dialogFour: 'Filtros, columnas',
            dialogFive: 'Empresa seleccionada',
            dialogSix: 'Filtros, columnas',
          },
          deleteSelective: 'Eliminar selectivo',
          selectiveDialog: 'Por favor, seleccione las configuraciones almacenadas que desea eliminar:',
        },
        constants: {
          Dashboard: {
            TIMEFRAME: 'Marco de tiempo',
            CHART_FILTERS: 'Filtros de gráficos',
            CHARTS: 'Gráficos',
          },
          Records: {
            HIGHLIGHTED: 'Vista previa',
            COLUMNS: 'Columnas',
            FILTERS: 'Filtros',
            SORT_COLUMN: 'Ordenar',
          },
          Actions: {
            FILTERS: 'Filtros',
            COLUMNS: 'Columnas',
          },
          Company: {
            SELECTED: 'Empresa seleccionada',
          },
          Tags: {
            FILTERS: 'Filtros',
            COLUMNS: 'Columnas',
          },
        },
      },
      assignmentsList: {
        filters: {
          companyName: 'Empresa',
          'leakStatus.building': 'Unidad/Edificio/Máquina',
          'leakStatus.facility': 'Instalación',
          'leakStatus.smartTag': 'Etiqueta inteligente #',
          'leakStatus.workRef': 'Ref. de trabajo #',
        },
        tableBody: {
          noAssignmentsToDisplay: 'No hay asignaciones para mostrar',
        },
        filtersCommonWords: {
          recordsFilter: 'Filtro de registros',
          column: 'Columna',
          selectAColumn: 'Selecciona una columna...',
          addSearchTerm: 'Añadir un término de búsqueda...',
          filtersArentAvailable: 'Los filtros no están disponibles',
          value: 'Valor',
          exportCSV: 'Exportar CSV',
          show: 'Mostrar',
          loadMoreRecords: 'Cargar más registros',
          selectedAllRecords: 'Seleccionado todos los registros ({{totalNum}})',
          selectedFromRecords: 'Seleccionado {{selectedNum}} de {{totalNum}} registros',
          reset: 'Restablecer',
        },
        invalidColumn: 'Columna no válida {{column}}',
        assignedActionRecords: 'Registros de acciones asignadas',
      },
      auth: {
        forgotPasswordView: {
          forgotYourPassword: '¿Olvidaste tu contraseña?',
          successMessage: 'Hemos enviado un correo electrónico de confirmación a',
        },
        authSuccess: {
          thanks: '¡Gracias!',
          backToLogin: 'Volver a la plataforma',
        },
        loginView: {
          forgotPass: '¿Olvidó la contraseña?',
          createAccount: 'Crear una cuenta',
          passwordIsRequired: 'Se requiere contraseña',
          resetPassword: 'Restablecer contraseña',
          contactSupport: 'Por favor, contacte a support@prosaris.ca',
          incorrectEmailOrPassword: 'Correo electrónico o contraseña incorrectos',
          resetPassDialog: {
            dialogOne: 'Debe restablecer su contraseña antes de continuar.',
            dialogTwo: 'Se le ha enviado un correo electrónico para restablecer la contraseña con instrucciones.',
          },
          ok: 'OK',
        },
        resetPasswordView: {
          passwordSuccessFullyReset: 'La contraseña se ha restablecido con éxito',
          enterNewPassword: 'Introduce tu nueva contraseña a continuación.',
          passwordChanged: 'Tu contraseña ha sido cambiada.',
        },
        createCompanyView: {
          companyName: 'Nombre de la empresa',
          companyNameIsRequired: 'Se requiere el nombre de la empresa',
          serialNumberIsRequired: 'Se requiere el número de serie del dispositivo',
          successTitle: '¡Felicidades! Su cuenta de {{companyName}} se ha creado con éxito.',
          successDescription:
            'Su cuenta de empresa ha sido creada. Puede agregar otros miembros del equipo a la empresa en la plataforma. Para preguntas adicionales, contacte a {{companyEmail}}.',
          companySetup: 'Configuración de la empresa',
          createCompany: 'Crear nueva empresa',
          createCompanyDescription:
            'Si su organización es nueva en la plataforma {{companyName}}, ahora puede crear su empresa en la plataforma. Usted será el administrador de la empresa.',
          deviceSerialNumber: 'Número de serie del dispositivo',
          or: 'O',
          joinExistingCompany: 'Unirse a una empresa existente',
          joinExistingCompanyDescription:
            'Si su organización ya tiene una cuenta de empresa registrada en la plataforma {{companyName}} y desea unirse, siga una de las siguientes opciones.',
          joinExistingCompanyOptions: {
            optionOne: 'Contáctenos en {{supportEmail}}. Un miembro del equipo lo añadirá a la empresa deseada.',
            optionTwo: 'Contacte al administrador de la empresa. Ellos pueden enviarle una invitación directamente desde la plataforma.',
          },
          essentialRoleMessage:
            'Su cuenta se encuentra automáticamente en el plan esencial. Para obtener más información sobre los diferentes planes de la plataforma {{companyName}}, contacte a {{supportEmail}}.',
          userRoleMessage:
            'Además, se ha añadido a {{companyName}} como usuario en la plataforma. Inicie sesión para acceder a su empresa.',
        },
        amazonRegistration: {
          selectYourCompany: 'Seleccione su empresa',
          selectCompanyDescription: 'Seleccione la empresa a la que desea unirse.',
          searchCompanies: 'Buscar empresas...',
          finishRegistration: 'Finalizar',
          cantFindCompany: '¿No encuentra su instalación?',
          cantFindCompanyStill: '¿Necesita ayuda?',
          cantFindCompanyDescription:
            'Si su organización ya tiene una cuenta de empresa registrada y desea unirse, siga una de las opciones a continuación.',
          cantFindCompanyOptionOne: 'Comuníquese con <a href="mailto:{{supportEmail}}"><strong>{{supportEmail}}</strong></a>.',
          companyRequired: 'Seleccione una empresa para continuar',
          registrationSuccess: '¡Cuenta creada con éxito! Inicie sesión.',
          registrationError: 'No se pudo crear la cuenta. Inténtelo de nuevo.',
          back: 'Atrás',
          addCompany: 'Agregar instalación',
          addCompanyTitle: 'Agregar nueva instalación',
          addCompanyDescription: 'Crear una nueva instalación bajo una empresa matriz.',
          selectParentCompany: 'Seleccionar empresa matriz',
          companyName: 'Nombre de la instalación',
          companyNamePlaceholder: 'ej., YYZ1',
          companyNameHelperText: 'Ingrese un código de instalación de 3 letras seguido de 1-2 dígitos (ej., YYZ1)',
          validatingAirportCode: 'Verificando código de instalación...',
          invalidAirportCode: 'Código de instalación no encontrado',
          networkError: 'Error de red. Por favor, inténtelo de nuevo.',
          validAirportCode: '{{municipality}}, {{country}}',
          companyNameRequired: 'El nombre de la empresa es requerido',
          parentCompanyRequired: 'La empresa matriz es requerida',
          invalidCompanyNameFormat: 'El nombre de la empresa debe ser un código de instalación seguido de 1-2 dígitos (ej., YYZ1, YYZ12)',
          createCompanySuccess: '¡Empresa {{name}} creada exitosamente!',
          createCompanyError: 'Error al crear la empresa. Por favor, inténtelo de nuevo.',
          cannotSelectFacility: 'No se puede crear una empresa bajo una instalación. Por favor, seleccione una empresa matriz.',
          pendingCompanySelected: 'La nueva empresa "{{name}}" se creará cuando finalice el registro.',
        },
      },
      calculateLeak: {
        index: {
          loadingLeakError: 'Error inesperado al cargar los datos de la fuga',
          calculatingError: 'Error inesperado durante el cálculo',
          dbMeasured: 'Db medido',
          calculate: 'Calcular',
          calculating: 'Calculando...',
          outflowCoefficient: 'Coeficiente de salida',
          kwhPerYear: 'Kwh/año',
        },
      },
      companies: {
        commonUsedWords: {
          assignedAdminLicenses: 'Licencias de administrador asignadas',
          company: 'Empresa',
          totalAccounts: 'Cuentas totales',
          email: 'Correo electrónico',
          name: 'Nombre',
          loadCompanyUsersError: 'Error al cargar usuarios de la empresa. Por favor, inténtelo de nuevo más tarde',
          activated: 'Activado',
          deactivated: 'Desactivado',
          activating: 'Activando',
          deactivating: 'Desactivando',
          deactivate: 'Desactivar',
          activate: 'Activar',
          set: 'Establecer',
          youAreGoingTo: 'Vas a',
          areYouSure: '¿Estás seguro?',
          companyNameIsRequired: 'Se requiere el nombre de la empresa',
          editCompany: 'Editar empresa',
          moveCompany: 'Mover empresa',
          createCompany: 'Crear empresa',
          viewHistory: 'Ver historial',
          onEssentialPlan: 'Estás en un plan esencial. Por favor, contacta con support@prosaris.ca',
          exportCSV: 'Exportar CSV',
        },
        groupPerformance: {
          title: 'Desempeño del Grupo',
          normalizeData: 'Normalizar Datos',
          selectTimeline: 'Seleccionar Cronología',
          selectCriteria: 'Seleccionar Criterios',
        },
        hubspotTickets: {
          title: 'Progreso de Incorporación',
          searchPlaceholder: 'Buscar tickets por instalación...',
          syncNow: 'Sincronizar Ahora',
          syncing: 'Sincronizando...',
          syncTooltip: 'Esto obtendrá las etapas y tickets más recientes de HubSpot',
          unmappedCompanies: 'Empresas sin mapear',
          notStartedOnboarding: 'No ha comenzado la incorporación',
          instructions:
            'Estos son los tickets de HubSpot que no tienen instalaciones correspondientes en la plataforma PROSARIS. Para crear un mapeo, siga los pasos a continuación:',
          step1: 'Crear una nueva instalación en la plataforma PROSARIS',
          step2Before: 'Haga clic en el',
          step2After: 'botón',
          noUnmappedTickets: 'No hay tickets sin mapear',
          noCompaniesWithoutOnboarding: 'No hay empresas sin incorporación',
          noTicketsInStage: 'No hay tickets en esta etapa',
          loadingPipelines: 'Cargando pipelines...',
          loadingTickets: 'Cargando tickets...',
          loadingCompanies: 'Cargando empresas...',
          errorLoadingPipelines: 'Error al cargar pipelines',
          noPipelinesAvailable: 'No hay pipelines disponibles',
          noStagesAvailable: 'No hay etapas disponibles',
          lastUpdated: 'Última actualización: ',
          syncSuccess: 'Datos de HubSpot sincronizados correctamente',
          syncPipelineFailed: 'Error al sincronizar pipeline de HubSpot',
          syncTicketsFailed: 'Error al sincronizar tickets de HubSpot',
        },
        charts: {
          chart: {
            criteria: {
              KWH: 'Total kWh/año',
              LOSS: 'Pérdida Total ($/año)',
              FLOW: 'Flujo Másico Total',
            },
            noDataAvailable: 'No hay datos disponibles',
            topNCompanies: 'Top {{numCompanies}} Empresas',
          },
        },
        accounts: {
          inviteUsers: {
            title: 'Invitar usuarios a {{companyName}}',
            emailAddresses: 'Direcciones de correo electrónico de los usuarios',
            emailsRequired: 'Se requieren direcciones de correo electrónico',
            successMessage: 'Usuarios invitados con éxito',
            note: 'Introduzca las direcciones de correo electrónico de los usuarios en una nueva línea o separadas por una coma.',
            tooltip: 'Cada usuario recibirá una invitación para unirse a la empresa.',
            invite: 'Invitar',
          },
          accountDialog: {
            companyIsRequired: 'Se requiere empresa',
            roleIsRequired: 'Se requiere rol',
            createAccountSuccessMessage: 'Cuenta creada con éxito',
            emailTakenErrorMessage: 'Una cuenta con este correo electrónico ya existe en el sistema',
            errorWhileCreatingAccountMessage: 'Error al crear una cuenta. Por favor, inténtelo de nuevo más tarde.',
            changeAccountSuccessMessage: 'Cuenta actualizada con éxito',
            errorWhileChangingAccountMessage: 'Error al actualizar la cuenta. Por favor, inténtelo de nuevo.',
            editAccount: 'Editar cuenta',
            createAccount: 'Crear cuenta',
            role: 'Rol',
          },
          changeOwner: {
            changeOwnerMessage: '¿También desea cambiar el propietario de los registros de fugas relacionados con esta cuenta?',
            no: 'No, mantener la cuenta actual en su lugar',
          },
          contentCell: {
            loadAccountRolesError: 'Error al cargar la información de los roles de la cuenta. Por favor, inténtelo de nuevo más tarde',
            changeRoleSuccessMessage: 'La cuenta {{email}} tiene un nuevo rol',
            changeRoleErrorMessage: 'Error al actualizar el rol para la cuenta {{email}}. Por favor, inténtelo de nuevo más tarde',
            editUser: 'Editar usuario',
            adminSetPassword: 'Administrador establece contraseña',
            adminSetSubRenewalDate: 'Fecha de renovación establecida por el administrador',
            resetPassword: 'Restablecer contraseña',
            user: 'Usuario',
            deleteUser: 'Eliminar usuario',
          },
          index: {
            noUsersToDisplay: 'No hay usuarios para mostrar',
            changeStatusSuccessMessage: 'Usuario {{isActive}} con éxito',
            changeStatusErrorMessage: 'Error al {{isActive}} usuario. Por favor, inténtelo de nuevo',
            changeOwnerSuccessMessage: 'Los registros se transfirieron a un nuevo propietario',
            changeOwnerErrorMessage:
              'No se pueden transferir los registros a un nuevo propietario. Por favor, inténtelo de nuevo más tarde',
            deleteAccountMutationSuccessMessage: 'La cuenta {{email}} ha sido eliminada con éxito',
            deleteAccountMutationErrorMessage:
              'No se puede eliminar la cuenta {{email}} en este momento. Por favor, inténtelo de nuevo más tarde',
            resetAccountPassWordSuccessMessage: 'Correo de restablecimiento de contraseña enviado con éxito',
            users: 'usuarios',
            noneAvailable: 'Ninguno disponible',
            of: 'de',
            contactSupport:
              'Por favor, contacte a support@prosaris.ca para obtener información adicional sobre las licencias de administrador de la empresa',
            findAccount: 'Buscar cuenta',
            placeholder: 'Escriba el nombre o el correo electrónico...',
            tooltip: 'Necesita al menos una licencia de administrador de la empresa antes de poder invitar a usuarios',
            invite: 'Invitar',
            alertDialog: {
              messageOne: 'Por favor, confirme la solicitud de restablecimiento de contraseña del usuario',
              messageTwo: 'Por favor, confirme el cambio de estado de la cuenta',
              messageThree: 'Por favor, confirme la eliminación de la cuenta',
            },
            sendAPasswordResetEmail: 'Va a enviar un correo de restablecimiento de contraseña para la siguiente cuenta:',
            confirmMessage: '¿Desea continuar?',
            followingAccount: 'siguiente cuenta:',
            delete: 'ELIMINAR',
            userCreatedDialogTitle: 'Enlace de restablecimiento de contraseña de usuario enviado con éxito',
            userCreatedDialogDescription:
              'Se ha enviado un enlace de restablecimiento de contraseña a la dirección de correo electrónico del usuario. También puede copiar el enlace a continuación.',
          },
          adminSetPassword: {
            changedUserPasswordSuccessMessage: 'Contraseña de la cuenta actualizada con éxito',
            changedUserPasswordErrorMessage: 'Error al actualizar la cuenta. Por favor, inténtelo de nuevo.',
            setNewPassword: 'Establecer nueva contraseña',
            accountPasswordUpdated: 'Contraseña de la cuenta actualizada',
            accountPasswordUpdatedDescription:
              'La contraseña de la cuenta se ha actualizado correctamente. Puede hacer clic en el botón de abajo para copiar la nueva contraseña.',
          },
          adminSetSubRenewalDate: {
            title: 'Establecer la fecha de renovación de la suscripción',
            subRenewalDate: 'Fecha de renovación de la suscripción',
            changedSubRenewalDateSuccessMessage: 'Fecha de renovación de la suscripción actualizada con éxito',
            changedSubRenewalDateErrorMessage: 'Error al actualizar la cuenta. Por favor, inténtelo de nuevo.',
          },
          setPassword: {
            automatic: 'Generar automáticamente una contraseña fuerte',
            manual: 'Crear contraseña manualmente',
            copyLinkInstruction: 'Podrás ver y copiar la contraseña en el siguiente paso',
          },
          userCreatedDialog: {
            title: 'Usuario creado con éxito',
            description:
              'Su nuevo usuario ahora puede comenzar a usar la plataforma. El usuario también recibirá un enlace por correo electrónico para restablecer su contraseña.',
            passwordCopied: 'Contraseña copiada al portapapeles',
            passwordResetLinkCopied: 'Enlace de restablecimiento de contraseña copiado al portapapeles',
            copyPassword: 'Copiar contraseña',
            copyPasswordResetLink: 'Copiar enlace de restablecimiento de contraseña',
          },
          useRoleOptions: {
            notAvailable: '(no disponible)',
            adminSeatTaken: '(el asiento de administrador está ocupado)',
            allSeatsAreTaken: '(todos los {{numSeats}} asientos están ocupados)',
            adminRolesTitle: 'Roles de administrador',
            roles: {
              superAdmin: 'Administrador raíz',
              companyAdmin: 'Empresa (Administrador)',
              superCompanyAdmin: 'Corporativo  (Administrador)',
              companyRead: 'Empresa (Solo lectura)',
              superAdminRead: 'Administrador raíz (solo lectura)',
              integrator: 'Integrador',
              auditor: 'Auditor',
              user: 'Usuario',
              essential: 'Prosaris Esencial',
              enterpriseAdmin: 'Administrador de empresa',
            },
            rolesDescriptions: {
              superAdmin: 'Permitido tener control total sobre múltiples empresas.',
              companyAdmin: 'Permitido ver, editar y asignar registros de la empresa.',
              superCompanyAdmin: 'Permitido tener control total sobre los registros y usuarios de la empresa.',
              companyRead: 'Permitido ver los registros de la empresa en modo de solo lectura.',
              superAdminRead: 'Permitido tener acceso de solo lectura a todas las empresas.',
              integrator: 'Permite integraciones de terceros para gestionar empresas y cuentas.',
              auditor: 'Para permitir la auditoría de registros de fugas.',
              user: 'Permitido crear/actualizar/eliminar sus propios registros.',
              essential: 'Un rol con funcionalidad limitada.',
              enterpriseAdmin: 'Permitido tener control total sobre los registros y usuarios de la empresa.',
            },
            nonAdminRolesTitle: 'Roles no administrativos',
          },
        },
        audits: {
          index: {
            loadAuditsErrorMessage: 'Error al cargar las auditorías. Por favor, inténtelo de nuevo más tarde',
            audits: 'auditorías',
            noAuditsToDisplay: 'No hay auditorías para mostrar',
            findByAuditorEmail: 'Buscar por correo electrónico del auditor',
            placeholder: 'Escriba el correo electrónico del auditor...',
          },
        },
        companyTabs: {
          facility: {
            index: {
              facilityNameIsRequired: 'Se requiere el nombre de la instalación',
              hoursYearlyIsRequired: 'Se requieren horas totales/año',
              totalHoursYearly: 'Las horas totales/año no pueden exceder de 8760',
              invalidPhoneNumber: 'Número de teléfono no válido',
              createErrorMessage: 'Horas x Turnos no puede exceder de 24 horas',
              loadFacilityErrorMessage: 'Error al cargar la instalación. Por favor, inténtelo de nuevo más tarde',
              createFacilitySuccessMessage: 'Instalación creada con éxito',
              createFacilityErrorMessage: 'Error al crear una instalación. Por favor, inténtelo de nuevo más tarde.',
              changeFacilitySuccessMessage: 'Instalación actualizada con éxito',
              changeFacilityErrorMessage: 'Error al actualizar la instalación. Por favor, inténtelo de nuevo.',
              facilityName: 'Nombre de la instalación',
              abbreviation: 'Abreviatura',
              address: 'Dirección',
              enterALocation: 'Ingresar una ubicación',
              tooltip: 'para actividades de gestión de energía, también aprobador de informes',
              energyMgtOwner: 'Propietario de Gestión Energética',
              title: 'Título',
              phone: 'Teléfono',
              tooltipTwo: 'para renovaciones de soluciones y problemas generales de la cuenta',
              accountOwner: 'Propietario de la cuenta',
              manufacturingArea: 'Área de producción',
              size: 'Tamaño',
              unit: 'Unidad',
              hoursOfOperation: 'Horas de operación',
              auditFrequency: 'Frecuencia de auditoría',
            },
            operationHours: {
              daysPerWeek: 'Días/Semana',
              shiftsPerDay: 'Turnos/Día',
              hoursPerShift: 'Horas/Turno',
              weeksPerYear: '52 semanas/año',
              totalHoursYearly: 'Total = Horas/Año',
            },
            constants: {
              constant: 'Constante',
              monthly: 'Mensual',
              threeMonth: '3 Meses',
              fourMonth: '4 Meses',
              sixMonth: '6 Meses',
              nineMonth: '9 Meses',
              annual: 'Anual',
              sqft: 'Pies cuadrados [SQFT]',
              sqm: 'Metros cuadrados [SQM]',
            },
          },
          index: {
            users: 'Usuarios',
            devices: 'Dispositivos',
            facility: 'Instalación',
            energy: 'Energía',
            seu: 'SEUs - Comp.',
            enpi: 'EnPIs/EnBs',
            routes: 'Rutas',
            audit: 'Auditorías',
            comingSoon: 'Próximamente...',
          },
        },
        enpis: {
          index: {
            loadEnpisErrorMessage: 'Error al cargar los EnPIs. Por favor, inténtelo de nuevo más tarde',
            createEnpisSuccessMessage: 'EnPIs creados con éxito',
            createEnpisErrorMessage: 'Error al crear los EnPIs. Por favor, inténtelo de nuevo más tarde.',
            changeEnpisSuccessMessage: 'EnPIs actualizados con éxito',
            changeEnpisErrorMessage: 'Error al actualizar los EnPIs. Por favor, inténtelo de nuevo.',
            showHistory: 'Mostrar historial',
          },
        },
        changeHistory: {
          bulkOperation: 'como una operación en masa',
          details: 'detalles',
          created: 'creado',
          updated: 'actualizado',
          componentTypes: {
            enpis: 'EnPIs',
            companies: 'Empresas',
          },
          history: 'Historial',
          noHistory: 'Sin historial',
        },
        energy: {
          index: {
            utilProvider: 'Proveedor de servicios públicos',
            energyUse: 'Uso de energía y tipo de consumo',
            error: {
              loadFacility: 'No se pudo cargar la instalación. Por favor, inténtelo de nuevo más tarde',
              loadEnergy: 'No se pudo cargar los datos de energía. Por favor, inténtelo de nuevo más tarde',
              loadUtilProviderLogo:
                'No se pudo cargar el logotipo del proveedor de servicios públicos. Por favor, inténtelo de nuevo más tarde',
              createEnergy: 'No se pudo crear los datos de energía. Por favor, inténtelo de nuevo más tarde',
              createUtilProviderLogo:
                'No se pudo subir el logotipo del proveedor de servicios públicos. Por favor, inténtelo de nuevo más tarde',
              updateEnergy: 'No se pudo actualizar los datos de energía. Por favor, inténtelo de nuevo más tarde',
              deleteUtilProviderLogo:
                'No se pudo eliminar el logotipo del proveedor de servicios públicos. Por favor, inténtelo de nuevo más tarde',
            },
            success: {
              createEnergy: 'Datos de energía creados con éxito',
              updateEnergy: 'Datos de energía actualizados con éxito',
            },
          },
          utilProvider: {
            index: {
              costOfEnergy: 'Costo de la energía',
              energySources: 'Fuentes de energía',
              incentiveRate: 'Tasa de Incentivo',
              per: 'por',
              validations: {
                utilProviderIsRequired: 'El proveedor de servicios públicos es obligatorio',
                costOfEnergyIsRequired: 'El costo de la energía es obligatorio',
                costOfEnergyMustBeNumber: 'El costo de la energía debe ser un número',
                costOfEnergyMustBeGreaterThanZero: 'El coste de energía debe ser mayor que 0',
                costOfRebateMustBeAtLeatZero: 'El costo de la rebaja debe ser al menos 0',
                costOfRebateMustBeNumber: 'El costo de la rebaja debe ser un número',
              },
            },
            UtilProviderLogo: {
              error: {
                fileSize: 'El tamaño del archivo debe ser inferior a 1 MB',
                preview: 'No se pudo previsualizar la imagen',
              },
              logo: 'Logotipo',
              addLogo: 'Agregar logotipo',
              removeLogo: 'Eliminar logotipo',
            },
            EnergySources: {
              energySource: 'Fuente de energía',
              percentage: 'Porcentaje',
              selectEnergySource: 'Seleccionar fuente de energía',
              addEnergySource: 'Agregar fuente de energía',
              totalPercentage: 'Porcentaje total',
              mustBeEqualTo100: '(debe ser igual al 100%)',
              constants: {
                energySources: {
                  NATURAL_GAS: 'Gas natural',
                  FUEL_OIL: 'Fuel Oil',
                  DIESEL: 'Diesel',
                  GASOLINE: 'Gasolina',
                  PROPANE: 'Propano',
                  COAL: 'Carbón',
                  WIND: 'Viento',
                  GEOTHERMAL: 'Geotérmica',
                  BIOMASS: 'Biomasa',
                  STEAM: 'Vapor',
                  COMPRESSED_AIR: 'Aire comprimido',
                  CHILLED_WATER: 'Agua fría',
                  NUCLEAR: 'Nuclear',
                  HYDRO: 'Hidroeléctrica',
                  SOLAR: 'Solar',
                },
              },
            },
          },
          energyUse: {
            index: {
              currentCalcApproach: 'Enfoque de cálculo actual',
              currentCalcApproachMessage:
                "Este enfoque de cálculo se aplica actualmente de forma predeterminada a todos los campos 'Costo de Energía', a menos que el usuario lo haya anulado.",
              alertTitle: 'Restablecer enfoque de cálculo',
              alertMessageOne:
                "Esta acción dejará de usar el enfoque de cálculo actual para todos los campos 'Costo de energía' en adelante.",
              alertMessageTwo: 'Tenga en cuenta que este cambio no afectará a ningún registro existente.',
              alertMessageThree: '¿Está seguro de que desea continuar con el restablecimiento?',
            },
            ReportType: {
              calcApproach: 'Enfoque de cálculo',
              constants: {
                calculations: {
                  FIXED: 'Eficiencia fija',
                  USDOE: 'DoE de los EE.UU.',
                  NREL: 'NREL Capítulo 22',
                },
              },
              setAsCurrent: 'Establecer como actual',
              setAsCurrentMessage: "Este enfoque de cálculo se utilizará para todos los campos 'Costo de Energía' en el futuro.",
            },
            calculations: {
              FixedEfficiency: {
                validations: {
                  efficiencyMustBeGreaterThanZero: 'La eficiencia debe ser mayor o igual a 0',
                  efficiencyMustBeNumber: 'La eficiencia debe ser un número',
                  operationHoursMustBeGreaterThanZero: 'Las horas de operación deben ser mayores o iguales a 0',
                  operationHoursMustBeLessThan8760: 'Las horas de operación deben ser menores a 8760',
                  operationHoursMustBeNumber: 'Las horas de operación deben ser un número',
                },
              },
              UsDoe: {
                loaded: 'Cargado',
                unloaded: 'Descargado',
                calcSummary: 'Resumen del cálculo',
                currentOperatingSystems: 'Sistemas operativos actuales',
                noCompsFoundAddCompOne: 'No se encontraron compresores. Agrega un compresor desde la',
                noCompsFoundAddCompTwo: 'pestaña de arriba.',
              },
            },
          },
        },
        compressors: {
          compressorDialog: {
            plateError: 'Error al cargar la placa de identificación. Por favor, inténtelo de nuevo más tarde.',
            dataSheetError: 'Error al cargar la hoja de datos. Por favor, inténtelo de nuevo más tarde.',
            createSuccess: 'Compresor {{tag}} creado',
            createError: 'Error al crear el compresor. Por favor, inténtelo de nuevo más tarde.',
            createCompressor: 'Agregar compresor',
            selectTemplate: 'Elija un compresor...',
            templatesError: 'Error al cargar las búsquedas de compresores. Inténtelo de nuevo más tarde.',
            searchPlaceholder: 'Buscar por modelo o marca... (ej.: G11-100, Atlas Copco)',
            templateDescription:
              'Un compresor de tipo Tornillo Rotativo puede añadirse eligiéndolo de la lista de compresores disponibles o completando la información manualmente. Si selecciona un compresor de la lista, el resto de la información se rellenará automáticamente. Siempre podrá ajustar la información más tarde. Los compresores de tipo Reciprocante y Centrífugo deberán introducirse manualmente.',
            quickSelectDescription: 'Elija de las búsquedas de compresores existentes',
            basicInfo: 'Información básica',
            basicInfoDescription: 'Detalles generales de identificación del compresor',
            technicalSpecifications: 'Especificaciones técnicas',
            technicalSpecificationsDescription: 'Parámetros de rendimiento y operación',
            documentation: 'Documentación',
            documentationDescription: 'Subir archivos y documentación del compresor',
            compressorSpecifications: 'Especificaciones del compresor',
            nameplate: 'Placa de características',
            motor: 'Motor',
            fullLoad: 'Carga completa',
            pressure: 'Presión',
            other: 'Otro',
            compressorFiles: 'Archivos del compresor',
            datasheetDisplayError: 'No se pudo mostrar el archivo de la hoja de datos',
            datasheetProcessError: 'No se pudo procesar el archivo de la hoja de datos',
          },
          compressorFile: {
            tip: 'Añadir archivo',
            removeFile: 'Eliminar archivo',
            removeImage: 'Eliminar imagen',
            title: 'Por favor, confirme la eliminación del compresor {{prop}}',
            proceed: '¿Quiere continuar?',
          },
          compressorForm: {
            compTagIsReq: 'La etiqueta del compresor es obligatoria',
            controlIsReq: 'Se requiere control',
            hpMustBeNum: 'La potencia nominal debe ser un número',
            capMustBeNum: 'La capacidad nominal debe ser un número',
            motorEffMustBeNum: 'La eficiencia del motor debe ser un número',
            motorVoltMustBeNum: 'El voltaje del motor debe ser un número',
            loadMustBeNum: 'La corriente a plena carga debe ser un número',
            loadInputMustBeNum: 'La potencia de entrada a plena carga debe ser un número',
            pressureMustBeNum: 'La presión nominal debe ser un número',
            setpointMustBeNum: 'El punto de ajuste de presión debe ser un número',
            airMustBeNum: 'El tamaño total de almacenamiento de aire debe ser un número',
            addImage: 'Agregar imagen',
            addFile: 'Agregar archivo',
          },
          constants: {
            compressorTypes: {
              ROTARY_SCREW: 'Tornillo rotativo',
              RECIPROCATING: 'Alternativo',
              CENTRIFUGAL: 'Centrífugo',
            },
            rotaryScrew: {
              loadUnloadOilFree: 'Carga/Descarga – Sin aceite',
              loadUnload1Gal: 'Carga/Descarga (1 gal/CFM)',
              loadUnload3Gal: 'Carga/Descarga (3 gal/CFM)',
              loadUnload5Gal: 'Carga/Descarga (5 gal/CFM)',
              loadUnload10Gal: 'Carga/Descarga (10 gal/CFM)',
              ivmWithBlowdown: 'Modulación de la válvula de entrada (sin descarga)',
              ivmWithoutBlowdown: 'Modulación de la válvula de entrada (con descarga)',
              variableDisplacement: 'Desplazamiento variable',
              vsdWithUnloading: 'Variador de frecuencia con descarga',
              vsdWithStopping: 'Variador de frecuencia con parada',
            },
            reciprocating: {
              reciprocatingOnOffControl: 'Control de encendido/apagado',
              reciprocatingLoadUnload: 'Carga/Descarga',
            },
            centrifugal: {
              centrifugalInletIgv: 'IBV con descarga',
              centrifugalInletIbv: 'IGV con descarga',
            },
          },
          contentCell: {
            min: '% debe ser al menos 0',
            max: '% no puede ser más de 100',
            max150: '% no puede ser más de 150',
            typeError: 'La carga debe ser un porcentaje válido',
            setpointMustBeNum: 'El punto de ajuste del compresor debe ser un número',
            flowMustBeNum: 'El flujo del compresor debe ser un número',
            pressureSetpointMustBeNum: 'El punto de ajuste de presión del sistema debe ser un número',
            measuredFlowMustBeNum: 'El flujo medido del sistema debe ser un número',
            dateTime: 'Selecciona fecha y hora',
            active: 'ACTIVO',
            off: 'APAGADO',
            trim: 'Ajuste',
            baseLoad: 'Carga base',
          },
          index: {
            error: 'Error al cargar los compresores. Por favor, inténtelo de nuevo más tarde',
            nameplateError: 'Error al cargar la placa de identificación. Por favor, inténtelo de nuevo más tarde',
            dataSheetError: 'Error al cargar la hoja de datos. Por favor, inténtelo de nuevo más tarde',
            changeCompSuccess: 'Compresor actualizado con éxito',
            changeCompError: 'Error al actualizar el compresor. Por favor, inténtelo de nuevo.',
            deleteCompSuccess: 'Compresor eliminado con éxito',
            deleteCompError: 'Error al eliminar el compresor. Por favor, inténtelo de nuevo.',
            createCompNameplateSuccess: 'Placa de identificación del compresor cargada con éxito',
            createCompNameplateError: 'Error al cargar la placa de identificación. Por favor, inténtelo de nuevo más tarde.',
            deleteCompNameplateSuccess: 'Placa de identificación del compresor eliminada con éxito',
            deleteCompNameplateError: 'Error al eliminar la placa de identificación del compresor. Por favor, inténtelo de nuevo.',
            createCompDataSheetSuccess: 'Hoja de datos del compresor cargada con éxito',
            createCompDataSheetError: 'Error al cargar la hoja de datos. Por favor, inténtelo de nuevo más tarde.',
            deleteCompDataSheetSuccess: 'Hoja de datos del compresor eliminada con éxito',
            deleteCompDataSheetError: 'Error al eliminar la hoja de datos del compresor. Por favor, inténtelo de nuevo.',
            changeCompanyCompSuccess: 'Datos del sistema actualizados con éxito',
            changeCompanyCompError: 'Error al actualizar los datos del sistema. Por favor, inténtelo de nuevo.',
            compDesignData: 'Datos de diseño del compresor',
            comp: 'Compresores:',
            addComp: 'Agregar compresor',
            editCompPermission: 'Necesitas una licencia de administrador para editar el compresor. Por favor, contacta',
            selectOption: 'Selecciona una opción',
            undoChanges: 'Deshacer cambios',
            selectComp: 'Selecciona un compresor de arriba.',
            noCompsFound: 'No se encontraron compresores.',
            compRunningState: 'Estado de funcionamiento del compresor',
            noCompsFoundAddComp: 'No se encontraron compresores. Agrega un compresor desde la sección de arriba.',
            title: 'Por favor, confirme la eliminación del compresor',
            areYouSure: '¿Estás seguro de que quieres',
            compressor: 'compresor',
            delete: 'eliminar',
          },
        },
        devices: {
          contentCell: {
            device: 'Dispositivo',
            usedByMultipleCompanies: 'es utilizado por varias empresas',
          },
          index: {
            noDevicesToDisplay: 'Ningún dispositivo ha registrado datos para esta empresa',
            loadingDevicesErrorMessage: 'Error al cargar los dispositivos de la empresa. Por favor, inténtelo de nuevo más tarde',
            changeStatusSuccessMessage: 'Dispositivo {{isActive}} con éxito',
            changeStatusErrorMessage: 'Error al {{isActive}} dispositivo. Por favor, inténtelo de nuevo',
            devices: 'dispositivos',
            findDevice: 'Buscar dispositivo',
            placeholder: 'Escriba el ID del dispositivo...',
            activatedOn: 'Activado el',
            title: 'Por favor, confirme el cambio de estado del dispositivo',
          },
        },
        company: {
          deleteCompanySuccessMessage: '{{companyName}} ha sido eliminado con éxito',
          deleteCompanyErrorMessage: 'Error al eliminar {{companyName}}. Por favor, inténtelo de nuevo más tarde.',
          needAdminLicense: 'Necesita una licencia de administrador para acceder a esta función. Por favor, contacte a support@prosaris.ca',
          deleteChildCompanyFirst:
            'No se puede eliminar la empresa con filiales o cuentas. Por favor, elimine primero todas las filiales y cuentas.',
          editSettings: 'Editar configuración',
          company: 'Empresa',
          createASubCompany: 'Crear una filial para {{companyName}}',
          deleteCompany: 'Eliminar empresa',
          cannotCreateChildCompanyDialog: {
            messageOne:
              'Ha alcanzado el número máximo de empresas que pueden ser creadas por sus cuentas de Corporativo. Por favor, contacte a ',
            messageTwo: 'para más detalles.',
          },
          deleteCompanyDialog: {
            title: 'Por favor, confirme la eliminación de la empresa',
            delete: 'Eliminar',
            deleting: 'Eliminando',
            permanentlyDeleted: 'lo eliminará permanentemente de nuestra base de datos.',
            cannotBeUndone: 'ESTA ACCIÓN NO SE PUEDE DESHACER.',
          },
        },
        companyDialog: {
          industryIsRequired: 'Se requiere industria',
          createLogoErroerMessage: 'Error al subir la imagen. Por favor, inténtelo de nuevo más tarde.',
          deleteLogoErrorMessage: 'Error al eliminar la imagen. Por favor, inténtelo de nuevo más tarde.',
          createCompanySuccessMessage: 'Empresa {{name}} creada',
          createCompanyErrorMessage: 'Error al crear la empresa. Por favor, inténtelo de nuevo más tarde.',
          changeCompanySuccessMessage: 'Empresa {{name}} actualizada',
          changeCompanyErrorMessage: 'Error al cambiar el parámetro de la empresa. Por favor, inténtelo de nuevo más tarde.',
          language: 'Idioma',
          industry: 'Industria',
          country: 'País',
          currency: 'Moneda',
        },
        companyLogo: {
          setImageErrorMessage: 'El tamaño del archivo debe ser inferior a 1 MB',
          logo: 'Logotipo',
          add: 'Añadir',
          removeLogo: 'Eliminar logotipo',
          addLogo: 'Añadir logotipo',
        },
        index: {
          loadCompaniesErrorMessage: 'Error al cargar la lista de empresas. Por favor, inténtelo de nuevo más tarde',
          loadAccountsErrorMessage: 'Error al cargar la lista de cuentas. Por favor, inténtelo de nuevo más tarde',
          changeCompaniesSectionWidth: 'Cambiar el ancho de la sección de empresas',
        },
        sidebar: {
          filterCompanies: 'Filtrar empresas',
          enterAtLeastNChatacters: 'Introduzca al menos {{length}} caracteres',
          placeholder: 'Introduzca el nombre de la empresa o el correo electrónico',
          myCompany: 'Mi empresa',
          childCompanies: 'Empresas filiales',
          moreCompany: '{{count}} empresa más',
          moreCompanies: '{{count}} empresas más',
        },
        routes: {
          commonUsedWords: {
            equipmentNameIsRequired: 'Se requiere el nombre del equipo',
            equipmentLocationIsRequired: 'Se requiere la ubicación del equipo',
            equipmentCriticalityIsRequired: 'Se requiere la criticidad del equipo',
            equipmentDescriptionIsRequired: 'Se requiere la descripción del equipo',
            name: 'Nombre',
            description: 'Descripción',
            location: 'Ubicación',
            criticality: 'Criticidad',
            actions: 'Acciones',
          },
          index: {
            routePlans: 'Planes de ruta',
            addRoute: 'Agregar ruta',
            routeRoutesExample: 'Ejemplo de rutas',
            pieceOfEquipment: '{{count}} pieza de equipo',
            piecesOfEquipment: '{{count}} piezas de equipo',
            equipment: 'Equipo',
            metrics: 'Métricas',
            settings: 'Configuración',
            noFloorPlan: 'No has subido un plano de planta para esta ruta',
            addFloorPlan: 'Agrega un plano de planta para comenzar a planificar visualmente tu ruta',
            routeEquipment: 'Equipos de la ruta',
            routeMetrics: 'Métricas de la ruta',
            metricsForRoute: 'Métricas para la ruta',
            totalRecords: 'Registros totales',
            totalOpenRecords: 'Registros abiertos totales',
            totalClosedRecords: 'Registros cerrados totales',
            totalLossPerYear: 'Pérdida total por año',
            totalKwhPerYear: 'kWh total por año',
            routeUpdatedSuccessfully: 'Ruta actualizada con éxito',
            routeRemovedSuccessfully: 'Ruta eliminada con éxito',
            routeSettings: 'Configuración de la Ruta',
            removeRoute: 'Eliminar Ruta',
            deleteRouteWarning:
              'Eliminar esta ruta eliminará la ruta, su equipo y su historial del sistema, pero dejará los datos históricos asociados a los registros.',
            areYouSure: '¿Está seguro de que desea eliminar esta ruta?',
            warningRemovingRoute: 'Eliminar la ruta la eliminará junto con su equipo y su historial del sistema de forma permanente.',
            thisActionCannotBeUndone: 'ESTA ACCIÓN NO SE PUEDE DESHACER.',
            noFacility: 'No tiene ninguna instalación definida',
            createAFacility: 'Cree una instalación para comenzar a planificar rutas',
            goToCreateAFacility: 'Ir a crear una instalación',
            createAFacilityTooltip: 'Debe crear una instalación antes de poder comenzar a planificar rutas.',
          },
          routeBuilder: {
            title: 'Constructor de Rutas',
            missingFields: 'Campos faltantes en el archivo cargado',
            facility: 'Instalación',
            route: 'Ruta',
            enterRoute: 'Ingrese la ruta',
            addFloorplan: 'Agregar plano de planta',
            floorplanInstructionsTooltip:
              'Agregue una imagen de un plano de planta para ayudarle a construir rutas. La ruta se superpondrá al plano cuando se guarde.',
            change: 'Cambiar',
            location: 'Ubicación',
            enterLocation: 'Ingrese la ubicación',
            equipment: 'Equipo',
            enterEquipment: 'Ingrese el equipo',
            criticality: 'Criticidad',
            enterCriticality: 'Ingrese la criticidad',
            description: 'Descripción',
            enterDescription: 'Ingrese la descripción',
            addEquipment: 'Agregar equipo',
            addRoute: 'Agregar ruta',
            downloadTemplate: 'Descargar plantilla',
            excelTemplate: 'Plantilla Excel (.xlsx)',
            csvTemplate: 'Plantilla CSV (.csv)',
          },
          fileReader: {
            loadFromFile: 'Cargar desde archivo',
            instructionsTooltip:
              'Puede importar equipos subiendo un archivo Excel (.xlsx, .xls) o CSV (.csv). El archivo debe tener las siguientes columnas: equipment_name, equipment_location, equipment_criticality, equipment_description. Descargue la plantilla proporcionada para comenzar.',
          },
          addRouteModal: {
            addRouteFor: 'Agregar ruta para {{facilityName}}',
            giveYourNewRouteAName: 'Asigne un nombre a su nueva ruta, describa su ubicación en la instalación y agregue su primer equipo',
            routeNameIsRequired: 'Se requiere el nombre de la ruta',
            routeLocationIsRequired: 'Se requiere la ubicación de la ruta',
            routeName: 'Nombre de la ruta',
            routeLocation: 'Ubicación de la ruta',
            firstPieceOfEquipment: 'Primer equipo',
            equipmentName: 'Nombre del equipo',
            equipmentCriticality: 'Criticidad del equipo',
            equipmentLocation: 'Ubicación del equipo',
            equipmentDescription: 'Descripción del equipo',
            locationTooltip: 'Explique dónde está ubicado en la instalación',
            equipmentLocationTooltip: 'Explique dónde está ubicado en la ruta',
            criticalityTooltip: 'Asigne una calificación de criticidad de equipo (ECR), generalmente un valor entre 1 y 5',
            downloadTemplate: 'Descargar plantilla',
            downloadCsvTemplate: 'Descargar plantilla CSV',
            downloadExcelTemplate: 'Descargar plantilla de Excel',
            manual: 'Manual',
            import: 'Importar',
            importedEquipments: 'Equipos importados',
            pleaseImportEquipment: 'Por favor, importe equipos o cambie al modo manual',
            equipmentOrderNote: 'Los equipos se añadirán a la ruta en el mismo orden en que aparecen en su archivo.',
            addFloorplan: 'Agregar plano de planta',
            change: 'Cambiar',
            floorplan: 'Plano de planta',
            noValidEquipmentDataFound: 'Se encontraron datos de equipos no válidos en el archivo. Consulte la plantilla.',
            equipmentItemsImportedSuccessfully: '{{count}} elementos de equipo importados correctamente',
            invalidFileFormat: 'Formato de archivo no válido. Utilice la plantilla proporcionada.',
            floorplanUploadedSuccessfully: 'Plano de planta subido con éxito',
            routeCreatedSuccessfully: 'Ruta creada con éxito',
            equipment: 'Equipo',
            equipments: 'Equipos',
            addEquipmentBefore: 'Agregar equipo antes',
            addEquipmentAfter: 'Agregar equipo después',
            addEquipmentBetween: 'Agregar equipo entre',
            removeEquipment: 'Eliminar equipo',
            floorplanIsRequired: 'Se requiere un plano de planta',
          },
          routeViewer: {
            showLabels: 'Mostrar etiquetas',
            hideLabels: 'Ocultar etiquetas',
            zoomIn: 'Acercar',
            zoomOut: 'Alejar',
            resetZoom: 'Restablecer zoom',
            centerView: 'Centrar vista',
            panUp: 'Arriba',
            panDown: 'Abajo',
            panLeft: 'Izquierda',
            panRight: 'Derecha',
          },
          routeEditorAddEquipmentAction: {
            addingNewEquipment: 'Agregar un nuevo equipo lo añadirá a la ruta después del equipo seleccionado.',
            addEquipment: 'Agregar equipo',
          },
          routeEditorAddWaypointAction: {
            waypoint: 'Punto de referencia',
            addingNewWaypoint:
              'Agregar un nuevo punto de referencia cambia la dirección de la ruta después del equipo seleccionado, pero no es un paso al ejecutar la ruta.',
            addWaypoint: 'Agregar punto de referencia',
          },
          routeEditorEditEquipmentAction: {
            updateEquipment: 'Actualizar equipo',
          },
          routeEditorEditFloorPlan: {
            floorPlan: 'Plano de planta',
            chooseFloorplan: 'Elegir un plano de planta',
          },
          routeEditorModal: {
            successRouteUpdated: 'Ruta actualizada con éxito',
            errorRouteUpdated: 'Error al actualizar la ruta. Por favor, inténtelo de nuevo más tarde.',
            successRouteDeleted: 'Ruta eliminada con éxito',
            errorRouteDeleted: 'Error al eliminar la ruta. Por favor, inténtelo de nuevo más tarde.',
            successFloorplanUpdated: 'Plano de planta actualizado con éxito',
            errorFloorplanUpdated: 'Error al actualizar el plano de planta. Por favor, inténtelo de nuevo más tarde.',
            unsavedChanges: '¿Tiene cambios sin guardar. ¿Está seguro de que desea salir?',
            back: 'Atrás',
            editEquipment: 'Editar equipo',
            youHaventUploadedFloorPlan: 'No ha subido un plano de planta. Desbloquee la edición visual subiendo un plano hoy.',
            addFloorPlan: 'Agregar plano de planta',
            addNewEquipment: 'Agregar nuevo equipo',
            removeEquipment: 'Eliminar equipo',
            swapEquipment: 'Intercambiar equipo',
            addWaypoint: 'Agregar punto de paso',
            changeFloorplan: 'Cambiar plano de planta',
            actions: {
              ADD_EQUIPMENT: 'Agregar Equipo',
              DELETE_NODE: 'Eliminar Nodo',
              SWAP_EQUIPMENT: 'Intercambiar Equipo',
              ADD_WAYPOINT: 'Agregar Punto de Referencia',
              CHANGE_FLOORPLAN: 'Cambiar Plano',
            },
          },
          routeEditorRemoveEquipmentAction: {
            youAreAboutToRemoveEquipmentFromTheRoute: 'Está a punto de eliminar el siguiente equipo de la ruta.',
            youAreAboutToRemoveWaypointFromTheRoute: 'Está a punto de eliminar el punto de referencia seleccionado de la ruta.',
            youWillNotLoseAnyHistoricalData:
              'No perderá ningún dato histórico, pero este {{type}} se eliminará de la ruta y no estará disponible para futuras ejecuciones.',
            equipment: 'equipo',
            waypoint: 'punto de referencia',
          },
          routeEditorSwapEquipmentAction: {
            replacementEquipmentIsRequired: 'Se requiere equipo de reemplazo',
            swappingEquipmentExplanation: 'El intercambio de equipos cambia la posición del equipo seleccionado con otro equipo.',
            swappingEquipmentCaption: 'Esto no afecta los datos históricos, pero cambiará el orden de los equipos en la ruta.',
            selectedEquipment: 'Equipo seleccionado',
            swapWith: 'Intercambiar con',
            selectEquipment: 'Seleccionar equipo',
            swapEquipment: 'Intercambiar equipo',
          },
        },
      },
      companySettings: {
        settings: {
          adminLicenses: {
            aal: 'Licencias de administrador asignadas',
            of: 'de',
            edit: 'Editar',
          },
          essentialMode: {
            disable: 'deshabilitar',
            enable: 'habilitar',
            essential: 'Modo esencial:',
            enabled: 'HABILITADO',
            disabled: 'DESHABILITADO',
            moveCompany: 'Mover la empresa {{company}} al modo esencial',
            affectedCompanies: 'Número de empresas afectadas',
            affectedAccounts: 'Número de cuentas afectadas',
            archivedLeak: 'Número de registros de eventos de fuga archivados',
            applyingChanges:
              'Al aplicar estos cambios, las cuentas obtendrán el rol "Esencial". Los usuarios podrán ver {{quota}} registros de eventos de fugas más recientes en un panel de control y una aplicación móvil. Otros registros serán archivados.',
            essentialLabel: 'Cambiar el modo esencial para subempresas',
            turnOffEssential: 'Desactivar el modo esencial para la empresa {{company}}',
            byApplyingChanges:
              'Al aplicar estos cambios, todas las cuentas obtendrán el rol de "Usuario". Los usuarios podrán ver todos sus registros. Todos los registros serán desarchivados.',
          },
          hubspotSync: {
            disable: 'desactivar',
            enable: 'activar',
            hubspot: 'Sincronización de HubSpot',
            enabled: 'ACTIVADO',
            disabled: 'DESACTIVADO',
            enableHubspotSync: 'Activar la sincronización de HubSpot para la empresa {{company}}',
            disableHubspotSync: 'Desactivar la sincronización de HubSpot para la empresa {{company}}',
            affectedCompanies: 'Número de empresas afectadas',
            applyingChanges: 'Al aplicar estos cambios, la sincronización de HubSpot estará {{status}}.',
            hubspotLabel: 'Cambiar la sincronización de HubSpot para las subempresas',
          },
          convertToSuperCompany: {
            title: 'Reestructurar empresa',
            newParentCompany: 'Nueva empresa principal',
            confirmChange: 'Confirmar nueva estructura de empresa',
            confirmChangeMessage: '¿Está seguro de que desea convertir {{child}} como la empresa secundaria de {{parent}}?',
            convertSuccess: 'Empresa reestructurada con éxito',
            convertError: 'Error al reestructurar la empresa. Por favor, inténtelo de nuevo más tarde.',
          },
          deploymentTransfer: {
            title: 'Transferir Empresa',
            senderTab: 'Origen',
            receiverTab: 'Destino',
            configured: 'Configurado',
            checkConfiguration: 'Verificar Configuración',
            configuredFrom: 'La configuración de transferencia se hereda de la empresa matriz',
            errorBoundary: 'Ocurrió un error al cargar Transferir Empresa. Por favor, actualice la página.',
            sender: {
              notConfigured: 'No Configurado',
              awaitingConnection: 'Esperando Conexión',
              awaitingS3Config: 'Configuración S3 Requerida',
              title: 'Configuración de Origen',
              description:
                'Configure esta implementación como el origen de la transferencia de datos. Comparta la clave API con el administrador del destino.',
              stepOne: 'Paso 1: Configurar URL de Destino',
              stepOneDescription: 'Ingrese la URL de la implementación de destino donde se transferirán los datos.',
              stepTwo: 'Paso 2: Compartir Clave API',
              stepTwoDescription: 'Copie esta clave API y compártala con el administrador del destino.',
              stepThree: 'Paso 3: Migración de Activos S3',
              stepThreeDescription: 'Configure el mapeo de buckets S3 para la migración de activos.',
              apiKey: 'Clave API',
              copyKey: 'Copiar Clave API',
              regenerateKey: 'Regenerar Clave API',
              keyCopied: 'Clave API copiada al portapapeles',
              keyRegenerated: 'Clave API regenerada correctamente',
              connected: 'Conectado al destino',
              connectedTo: 'Conectado a la empresa destino: {{companyId}}',
              notConnectedWarning: 'Advertencia: No conectado al destino.',
              targetUrl: 'URL de Destino',
              lambdaFunction: 'Nombre de Función Lambda',
              bucketAutoConfig: 'Los buckets se configuran automáticamente durante el proceso de enlace.',
              saveSuccess: 'Configuración de origen guardada correctamente',
              saveError: 'Error al guardar la configuración del emisor',
              regenerateError: 'Error al regenerar la clave API',
              deleteConfig: 'Eliminar Configuración',
              deleteConfirmMessage: 'Esto eliminará la configuración del emisor y desconectará el destino. ¿Desea continuar?',
              deleteSuccess: 'Configuración de origen eliminada correctamente',
              deleteError: 'Error al eliminar la configuración del emisor',
            },
            receiver: {
              notConfigured: 'No Configurado',
              title: 'Configuración de Destino',
              description: 'Configure esta implementación como destino de la transferencia de datos.',
              sourceUrl: 'URL de Origen',
              apiKey: 'Clave API',
              apiKeyPlaceholder: 'Pegue la clave API de 64 caracteres',
              invalidApiKey: 'La clave API debe tener exactamente 64 caracteres',
              connected: 'Conectado',
              pending: 'En Espera',
              connectedFrom: 'Conectado desde la empresa origen: {{companyId}}',
              saveAndConnect: 'Guardar y Conectar',
              connectionSuccess: 'Conectado correctamente al origen',
              handshakePending: 'Configuración guardada. En espera de enlace.',
              saveError: 'Error al guardar la configuración del receptor',
              deleteConfig: 'Eliminar Configuración',
              deleteConfirmMessage: 'Esto eliminará la configuración del receptor y desconectará el origen.',
              deleteSuccess: 'Configuración de destino eliminada correctamente',
              deleteError: 'Error al eliminar la configuración del receptor',
            },
            operations: {
              title: 'Operaciones de Transferencia',
              description: 'Transferir datos y recursos desde este despliegue al despliegue destino.',
              notConnected: 'Advertencia: No conectado al despliegue destino. Asegúrese de que el receptor haya guardado la clave API.',
              stepTransferData: 'Paso 1: Transferir Datos',
              stepTransferAssets: 'Paso 2: Transferir Recursos',
              transferComplete: 'Transferencia Completa',
              completed: 'Completado',
              inProgress: 'En Progreso',
              notStarted: 'No Iniciado',
              pending: 'Pendiente',
              transferAll: 'Transferir Todas las Colecciones',
              refreshStatus: 'Actualizar Estado',
              migrateS3: 'Migrar Recursos S3',
              transferStarted: 'Transferencia iniciada correctamente',
              transferError: 'Error al iniciar la transferencia',
              s3MigrationStarted: 'Migración de recursos S3 iniciada',
              s3MigrationError: 'Error en la migración de recursos S3',
              overallStatus: 'Estado General',
              totalDuration: 'Duración Total',
              completedAt: 'Completado el',
              initiatedBy: 'Iniciado por',
              collection: 'Colección',
              status: 'Estado',
              documents: 'Documentos',
              duration: 'Duración',
              assetType: 'Tipo de Recurso',
              documentsProcessed: 'Documentos Procesados',
              parentTransferDescription:
                'Todas las empresas matriz deben completar su transferencia antes de transferir esta empresa. Transfiera en el siguiente orden:',
            },
          },
          index: 'Configuración',
        },
        index: {
          loadCompanyError: 'No se puede cargar la información de la empresa. Por favor, inténtelo de nuevo más tarde',
          companySlug: 'Alias de la empresa',
          notSelected: 'No seleccionado',
          country: 'País',
          accounts: 'Cuentas',
          currency: 'Moneda',
          adminLicenses: 'Licencias de administrador',
          totalCustomer: 'Total de cuentas de clientes en el árbol',
        },
      },
      device: {
        registerDeviceView: {
          registerDevice: 'Registre su dispositivo',
          toolTip: 'Por favor, localice el número de serie en su tarjeta de registro o en la caja.',
          serialNumberIsRequired: 'Se requiere el número de serie',
          oops: '¡Ups!',
          deviceNotFound: 'Número de serie del dispositivo no encontrado',
          deviceFoundNdAssociatedCompany: 'Su dispositivo fue encontrado y está asociado con una empresa.',
          deviceFound: 'Su dispositivo fue encontrado.',
          goToLogin: 'Ir a iniciar sesión',
          contactSupport: 'Por favor, contacte con el soporte',
        },
        deviceErrorCodes: {
          'B13:001': 'Número de serie del dispositivo no encontrado',
          'B13:002': 'Dispositivo ya activado',
          'B13:003': 'Correo electrónico de administrador no enviado',
          'B13:004': 'Empresa no encontrada',
          'B13:005': 'Empresa no válida',
          'B13:006': 'Tipo inválido',
        },
        registerAccountView: {
          createAccountSuccess: 'Cuenta creada con éxito',
          createAccountError: 'Error al crear la cuenta. Por favor, contacte con support@prosaris.ca',
          registerAccount: 'Crear una cuenta',
          termsMustBeAccepted: 'Se deben aceptar los términos y condiciones.',
          saleType012Success: 'Puedes iniciar sesión para comenzar a usar tu dispositivo.',
          saleType3Success: 'Has sido agregado como usuario básico. Los administradores de tu empresa han sido notificados.',
          saleType4Success: {
            companyPlatformFound: 'Licencia de plataforma empresarial encontrada.',
            dialogOne: 'Este dispositivo está asociado con una nueva licencia de plataforma empresarial.',
            dialogTwo: 'Your company may already exist in our system.: Es posible que tu empresa ya exista en nuestro sistema.',
            dialogThree: 'If so, please contact your administrator.: Si es así, por favor contacta a tu administrador.',
          },
          termsAndConditions: {
            dialogOne: 'IAcepto los',
            dialogTwo: 'Términos de Servicio',
            dialogThree:
              'de Prosaris y confirmo que he tenido suficiente tiempo para leerlos y entender que contienen términos importantes sobre mi uso del software de Prosaris, como la limitación de la responsabilidad de Prosaris y cómo se manejarán mis datos.',
          },
          termsOfServiceModal: {
            termsOfService: 'Términos de servicio',
          },
          acceptTerms: 'Aceptar términos',
          registerAccountErrorCodes: {
            'B02:001': 'Código de registro inválido',
            'B02:002': 'Empresa de usuario inválida',
            'B02:003': 'Rol de usuario inválido',
            'B02:004': 'El correo ya está en uso',
            'B02:005': 'El correo ya está en uso',
            'B02:006': 'No se puede restablecer la contraseña para su cuenta',
            'B02:007': 'Empresa de usuario inválida',
            'B02:008': 'Falta foto de perfil',
            'B02:009': 'Se requiere restablecer la cuenta. El proceso ha comenzado',
            'B02:010': 'La cuenta ha sido desactivada',
            'B02:011': 'Formato de foto de perfil inválido',
            'B02:012': 'Dispositivo ya registrado en una empresa',
            'B02:013': 'SNúmero de serie indefinido',
            'B02:014': 'Tipo inválido',
            'B02:015': 'Enlace para restablecer contraseña ha expirado',
            'B02:016': 'No se puede crear una cuenta para esta empresa',
            'B02:017': 'Rol inválido',
            'B02:018': 'Rol inválido',
            'B02:019': 'Empresa de usuario inválida',
            'B02:020': 'Rol de usuario inválido',
            'B02:021': 'El usuario no pertenece a esta empresa',
          },
          whichProduct: '¿Qué producto tiene?',
        },
        devicesView: {
          serialNumbersIsReq: 'Se requieren números de serie',
          failedToCopy: 'Números de serie fallidos copiados al portapapeles',
          invalidFormat: 'Uno o más dispositivos tienen un formato no válido. Por favor, verifique e intente de nuevo.',
          devices: 'Registre sus dispositivos',
          deviceSerialNumber: 'Número(s) de serie del dispositivo',
          note: 'Ingrese cada número de serie en una nueva línea o separado por una coma.',
          title: 'Ubique el número de serie en su tarjeta de registro o en la caja.',
          register: 'Registrar',
          deviceRegistrationStatus: 'Estado de registro del dispositivo',
          success: 'Éxito',
          noDeviceFound: 'No se encontraron dispositivos.',
          failed: 'Fallido',
          copyFailed: 'Copiar los números de serie fallidos al portapapeles',
        },
      },
      errors: {
        notFoundView: {
          title: 'La página que buscas no está aquí',
          description: 'O bien has intentado una ruta dudosa o has llegado aquí por error. Sea lo que sea, intenta usar la navegación.',
        },
        accountNotFound: {
          title: 'Cuenta no encontrada',
          description:
            '¡Inténtalo de nuevo! Si el problema persiste, es posible que tu cuenta esté inactiva o que no haya sido inicializada por el administrador. Por favor, contacta con tu administrador.',
          logout: 'Cerrar sesión',
        },
      },
      integration: {
        index: {
          loggingInError: 'Error al iniciar sesión en Prosaris.',
        },
      },
      leakRecordDetails: {
        assignedActions: {
          actionImages: 'No hay imágenes disponibles',
          activeActionRecord: {
            updateAssignmentSuccess: 'La acción asignada ha sido actualizada.',
            updateAssignmentError: 'Error al actualizar la acción asignada.',
            deleteImageSuccess: 'La imagen asignada ha sido eliminada.',
            deleteImageError: 'Error al eliminar la imagen de la acción asignada.',
            confirmMarkAction:
              'Completar esta tarea marcará el registro como completo y todas sus acciones asociadas como inactivas. ¿Está seguro de que desea continuar?',
            confirmDeleteImage: '¿Realmente quiere eliminar esta imagen?',
          },
          index: 'Error al cargar las acciones asignadas para un registro.',
        },
        audio: {
          noAudioAvailable: 'No hay datos de audio disponibles',
          errorDownloadingAudio: 'Error al descargar el audio. Por favor, inténtelo de nuevo más tarde.',
          playPause: 'Reproducir / Pausar',
          generateRegion: 'Generar Región',
          removeLastRegion: 'Eliminar Última Región',
          generateMarker: 'Generar Marcador',
          removeLastMarker: 'Eliminar Último Marcador',
          toggleTimeline: 'Alternar Línea de Tiempo',
          download: 'Descargar',
        },
        audit: {
          updateAuditSuccess: 'Auditoría actualizada con éxito',
          updateAuditError: 'Error al guardar el comentario. Por favor, inténtelo de nuevo más tarde.',
          createAuditSuccess: 'Auditoría creada con éxito',
          createAuditError: 'Error al crear la auditoría. Por favor, inténtelo de nuevo más tarde.',
          deleteAuditSuccess: 'La auditoría ha sido eliminada con éxito',
          deleteAuditError: 'No se pudo eliminar la auditoría. Por favor, inténtelo de nuevo más tarde.',
          noComment: 'Sin comentarios',
          reviewComments: 'Revisar comentarios',
          reviewedBy: 'Revisado por:',
          auditDate: 'Fecha de la auditoría:',
          deleteAudit: 'Eliminar auditoría',
          reviewedNoComments: 'Revisado sin comentarios',
          auditComments: 'Comentarios de la auditoría',
          saveComment: 'Guardar comentario',
          discardChanges: 'Descartar cambios',
        },
        changeHistory: {
          created: 'creado',
          updated: 'actualizado',
          deleted: 'eliminado',
          transferred: 'transferido',
          synced: 'sincronizado',
          leak: 'Registro',
          images: 'Imagen',
          audit: 'Auditoría',
          audio: 'Audio',
          history: 'Historial',
          noHistory: 'Sin historial',
          bulk: 'como una operación en bloque',
          details: 'detalles',
          unset: 'sin definir',
        },
        fft: {
          fft: 'FFT (Transformada Rápida de Fourier)',
          fftAvg: 'Promedio FFT',
          notApplicable: 'No aplicable',
          chartLayers: 'Capas del gráfico',
          avg: 'Promedio',
          all: 'Todo',
          playing: 'Reproduciendo...',
          showTimeSeries: 'Mostrar serie temporal',
        },
        form: {
          updateLeakSuccess: 'Actualizado con éxito.',
          updateLeakError: 'Error al actualizar la fuga. Por favor, inténtelo de nuevo más tarde.',
          alertTitle: {
            partOne: 'El registro está en',
            partTwo: 'modo solo lectura',
            partThree: '.',
          },
          alertDialog: {
            dialogOne: 'Sin embargo, se pueden modificar las siguientes propiedades:',
            dialogTwo: 'Estado de la acción',
          },
          GPSLocation: 'Ubicación GPS',
          completedOn: 'Completado el:',
          lastSaved: 'Última guardado:',
          updateConfirmMessage:
            'Completar este registro marcará todas sus acciones asociadas como inactivas. ¿Está seguro de que desea continuar?',
          updateConfirmTitle: 'Confirmar finalización del registro',
          smartTagHelp: 'Más información sobre PROSARIS Smart Tags',
        },
        images: {
          removeSuccess: 'Imagen eliminada con éxito.',
          removeError: 'No se puede eliminar la imagen del registro de fugas. Por favor, inténtelo de nuevo más tarde.',
          text: '¿Estás seguro de que quieres eliminar esta imagen?',
          addImages: 'Agregar imágenes',
          additionalImages: 'Imágenes Adicionales',
          noAdditionalImages: 'Sin imágenes adicionales',
          uploadSuccess: 'Imagen(es) cargada(s) exitosamente.',
          uploadError: 'No se puede cargar la imagen. Por favor, inténtelo de nuevo más tarde.',
          maxImagesReached: 'Máximo de 10 imágenes adicionales por registro.',
          tooManyFiles: 'No se pueden agregar {{count}} imágenes. Solo se permiten {{remaining}} más.',
        },
        index: {
          title: 'Registro',
          loadingError: 'Error al cargar el registro de fugas. Por favor, inténtelo de nuevo.',
          unsavedMessage: "Al presionar 'Ok', confirma que todos los cambios no guardados se eliminarán",
          notAnAuditor: 'No eres auditor',
          anEssential: 'Estás en un plan esencial',
          showHistory: 'Mostrar historial',
        },
        massFlow: {
          recalculating: 'Recalculando Flujo/Pérdida según los parámetros de fuga...',
          warning:
            'Los valores de entrada han cambiado o el cálculo está desactualizado, presione "Recalcular" para actualizar los valores de Flujo y Pérdida',
          calculatingError: 'Error al calcular el flujo de masa. Por favor, inténtelo de nuevo más tarde.',
          noValue: 'Sin valor',
          calculatingSuccess: 'Flujo/Pérdida recalculado',
          recalculate: 'Recalcular',
          calculatorVersion: 'Versión de cálculo:',
          noteDialog: {
            dialogOne: 'Cambiar los parámetros de la fuga actualizará el cálculo de Flujo/Pérdida. Verificar',
            dialogTwo: 'Información de cálculo',
            dialogThree: 'página para más información',
          },
        },
        unsavedWarningDialog: {
          recordChanged: 'El registro ha sido modificado',
          close: 'Cerrar',
          unsavedChanges: 'Este registro tiene cambios no guardados. Por favor, considere guardar esos cambios o eliminarlos por completo.',
          discardChanges: 'Descartar cambios',
        },
      },
      leakRecordCreate: {
        form: {
          deviceIDIsRequired: 'Se requiere ID del dispositivo',
          dbPeakIsRequired: 'Se requiere el DB de pico medido',
          dbMin: 'El DB de pico medido debe ser mayor o igual a 0',
          dbMax: 'El DB de pico medido debe ser menor o igual a 95',
          dbError: 'El DB de pico medido debe ser un número',
          imageUploadError: 'Error al cargar la imagen. Por favor, inténtelo de nuevo más tarde.',
          createLeakSuccess: 'Registro añadido con éxito',
          createLeakError: 'Error al crear el registro. Por favor, inténtelo de nuevo más tarde.',
          basicInfo: 'Información básica',
          flowInput: 'Entrada de flujo',
          mainGas: 'Gas/Componente principal de interés',
          selectComponent: 'Seleccionar componente',
          selectLeakType: 'Seleccionar tipo de fuga',
          mightBeSomethingHere: 'no seguro aún',
          energyLoss: 'Pérdida de energía',
          selectCompressorType: 'Seleccionar tipo de compresor',
          noRoutes: 'No se encontraron rutas',
          noEquipment: 'No se encontró equipo',
          noRouteEquipment: 'No se encontró equipo de ruta',
          routeEquipmentInfo: 'Detalles del equipo de ruta',
          noLocations: 'No se encontraron ubicaciones',
          energyCost: 'Costo de energía',
          audioRecording: 'Grabación de Audio',
          leakSourceEquipment: 'Fuente',
          selectComponentType: 'Seleccionar tipo de componente',
          selectService: 'Seleccionar servicio',
          locationAndUser: 'Ubicación y usuario',
          leakEventStatus: 'Estado del evento',
          low: 'Bajo',
          medium: 'Medio',
          high: 'Alto',
          open: 'Abrir',
          complete: 'Completo',
          reset: 'Restablecer',
        },
        formElectrical: {
          systemVoltages: 'Voltajes del sistema',
          source: 'Fuente',
        },
        images: {
          leakSourceImageCapture: 'Captura de Imagen de Fuente',
          add: 'Añadir',
        },
        index: {
          title: 'Crear registro',
        },
      },
      leakRecordsList: {
        filters: {
          from: 'Desde',
          to: 'Hasta',
          qualifier: 'Calificador',
          savedFilters: 'Filtros guardados',
          filter: 'Filtro',
          selectFilter: 'Seleccione un filtro...',
          filterName: 'Nombre del filtro',
          filterNameRequired: 'El nombre del filtro es obligatorio',
          filtersNotAvailable: 'Filtros no disponibles',
          saveFilterTitle: 'Guardar filtro',
          deleteSavedFilterTitle: 'Por favor confirme la eliminación del filtro',
          deleteSavedFilterMessage: '¿Está seguro de que desea eliminar el filtro "{{savedFilterName}}"?',
          createFilterSuccess: "El filtro '{{filter}}' se creó con éxito. Puede acceder a él en Filtros de registros → Filtros guardados",
          createFilterError: 'Error al crear el filtro. Por favor, inténtelo de nuevo más tarde.',
          deleteFilterSuccess: 'Filtro eliminado con éxito',
          deleteFilterError: 'Error al eliminar el filtro. Por favor, inténtelo de nuevo más tarde.',
          emptyFilter: 'Está vacío',
        },
        modalAssignUsers: {
          assignLeakRecord: 'Asignar registro',
          selectAUserToAssign: 'Seleccione un usuario que debería ser asignado a los registros seleccionados',
          filterByName: 'Filtrar por nombre',
          filterByEmployeeName: 'Filtrar por nombre de empleados',
          unexpectedError: 'Ocurrió un error inesperado',
          noUserFound: 'No se encontraron usuarios',
          assigningActionForSelectedRecords: 'Asignando acción para los registros seleccionados...',
        },
        modalTransferRecords: {
          transferRecords: 'Transferir registros',
          selectCompany: 'Seleccionar empresa',
          selectCompanyPlaceholder: 'Selecciona una empresa',
          selectUser: 'Seleccionar usuario',
          selectUserPlaceholder: 'Selecciona un usuario',
          noUserFound: 'No se encontró usuario',
          unexpectedError: 'Error inesperado',
        },
        modalBulkEdit: {
          titleSingleRecord: 'Edición masiva de {{selectedRecordsCount}} registro',
          title: 'Edición masiva de {{selectedRecordsCount}} registros',
          selectAField: 'Seleccione un campo',
          verifyAction:
            'Está a punto de actualizar registros que pertenecen a otros usuarios. Confirme introduciendo el número de registros seleccionados a continuación.',
          matchCountError: 'Debe coincidir con el número de registros seleccionados ({{selectedRecordsCount}})',
          moreThanOneType:
            'Los registros seleccionados tienen más de un tipo. Algunos campos pueden no estar disponibles para la edición masiva.',
          companyFilterRequired:
            'Para editar campos de ruta, primero aplique un filtro de Empresa. Las rutas son específicas de la empresa/instalación.',
          selectCompanyForRoute:
            'Las rutas son específicas de la empresa/instalación. Al seleccionar una empresa se aplicará un filtro y se cerrará este cuadro de diálogo. Deberá volver a seleccionar sus registros y abrir la edición masiva de nuevo.',
        },
        tableHead: {
          youAreSelecting: 'Estás seleccionando:',
          visibleRecords: 'registros visibles',
          andAllUnloadedRecords: 'y todos los registros no cargados.',
          allRecordsWillBeLoaded: 'Todos los registros serán cargados y seleccionados.',
          thisCanTakeAWhile: 'Esto puede tardar un tiempo si tienes muchos registros.',
          allRecords: 'Todos los registros, incluidos los invisibles',
          selectAllRecords: 'Seleccionar todos los registros.',
        },
        tableBody: {
          noRecordsToDisplay: 'No hay registros para mostrar.',
        },
        toolBar: {
          assign: 'Asignar',
          assignToSelf: 'Asignar a mí mismo',
          assignToSelfDialogTitle: 'Confirmar asignación de registros',
          assignToSelfDialogMessage: '¿Está seguro de que desea asignarse {{len}} registro(s)?',
          onEssentialPlan: 'Estás en un plan esencial. Por favor, contacta con support@prosaris.ca',
          bulkEdit: 'Edición masiva',
          transfer: 'Transferir',
          bulkEditSuccess: '{{len}} registro actualizado con éxito',
          bulkEditSuccessPlural: '{{len}} registros actualizados con éxito',
          bulkEditError: 'Error al actualizar los registros. Por favor, inténtelo de nuevo más tarde',
          export: 'Exportar',
          exportPDF: 'Exportar PDF',
          needAdminLicense:
            'Necesitas una licencia de administrador para acceder a esta función. Por favor, contacta con support@prosaris.ca',
          create: 'Crear',
          deleteRecordMessage: '¿Estás seguro de que quieres eliminar el registro seleccionado?',
          deleteRecordMessagePlural: '¿Estás seguro de que quieres eliminar los registros seleccionados?',
          permissionDenied: '¡Permiso denegado!',
          notAllowedToDelete:
            'Has seleccionado un registro de alguien que no tienes permitido eliminar. Por favor, quítalo de la selección.',
          generatingPDF: 'Generando PDF...',
          csvExportProcessing: 'Su archivo está siendo procesado. Se descargará automáticamente.',
          cannotGeneratePDF:
            'Desafortunadamente, no podemos exportar {{numberSelected}} registros en un documento PDF ahora mismo. Por favor, selecciona hasta {{limitRecords}} registros.',
          cannotExportMessage: 'No se pueden exportar {{numberSelected}} registros',
          bulkEditLimitExceeded:
            'No se pueden editar más de {{maxAllowed}} registros. Por favor, póngase en contacto con support@prosaris.ca',
          selectAtLeastOneRecord: 'Por favor, seleccione al menos un registro',
        },
        index: {
          cannotLoadLeakRecord: 'Lo siento, no podemos cargar el registro de fuga en este momento',
          successfullyAssignedAllRecords: 'Todos los registros asignados con éxito',
          actionRecordAssigned: '¡Registro de acción asignado!',
          actionRecordAssignedPlural: '¡Registros de acción asignados!',
          errorWhileAssigningLeak: 'Error al asignar la fuga. Por favor, inténtalo de nuevo más tarde.',
          successfullyDeletedAllRecords: 'Todos los registros eliminados con éxito',
          successfullyDeletedRecord: '{{length}} registro de fuga eliminado con éxito',
          successfullyDeletedRecordPlural: ' {{length}} registros de fuga eliminados con éxito',
          errorOnRecordsDelete: 'Error al eliminar registros. Por favor, inténtelo de nuevo más tarde',
          leakPreview: 'Vista previa',
          leakRecord: 'Registro: ',
          failedAssignments: 'Asignaciones fallidas ({{failed}})',
          failedAssignmentCodes: {
            'B04:012': 'El registro está cerrado',
          },
          displayedRows: '{{from}}-{{to}} de {{count}}',
          rowsPerPage: 'Filas por página:',
          previousPage: 'Página anterior',
          nextPage: 'Página siguiente',
          csvExportSuccess: 'Exportación completada con éxito',
          csvExportError: 'Error al exportar. Por favor, inténtelo de nuevo más tarde.',
        },
      },
      tagList: {
        resetTag: 'Restablecer etiqueta',
        dataExport: {
          smartLeakTagsFormat: 'Formato de Smart Tags',
          smartLeakTagsDescription: 'Contiene los campos predeterminados presentes en la página de Smart Tags',
          standardLeakRecordFormat: 'Formato de registro estándar',
          standardLeakRecordDescription: 'Contiene todos los campos relacionados con los registros de fugas',
        },
        filters: { smartLeakTagFilters: 'Filtros de Smart Tag' },
        index: {
          cannotLoadTags: 'Lo sentimos, no podemos cargar Smart Tag en este momento',
          updateLeakSuccess: 'Restablecimiento de Smart Tag exitoso.',
          updateLeakError: 'Error al restablecer Smart Tag. Por favor, inténtelo de nuevo más tarde.',
          bulkEditSuccess: 'Restablecidos con éxito {{len}} Smart Tag',
          bulkEditSuccessPlural: 'Restablecidos con éxito {{len}} Smart Tags',
          bulkEditError: 'Error al restablecer Smart Tags. Por favor, inténtelo de nuevo más tarde.',
          tagsFileName: 'Smart Tags',
          leakFileName: 'Registros',
        },
        tableBody: {
          title: 'Por favor, confirme el restablecimiento de la etiqueta',
          alertDialog: {
            dialogOne: 'Estás tratando de',
            dialogTwo: 'restablecer la etiqueta',
            dialogThree: 'de un registro de fuga con',
            dialogFour: 'Estado de la acción: ABIERTO',
            dialogFive: '¿Quieres continuar?',
          },
        },
        toolBar: {
          resetTags: 'Restablecer etiquetas',
          title: 'Por favor, confirme el restablecimiento masivo de las etiquetas',
          alertDialog: {
            dialogOne: 'Su selección contiene',
            dialogTwo: 'registro con',
            dialogTwoPlural: 'registros con',
            dialogThree: 'Estado de la acción: ABIERTO',
            dialogFour: '¿Quieres continuar?',
          },
          exportFormatCSV: 'Seleccione un formato de exportación para CSV',
          exportFormatPDF: 'Seleccione un formato de exportación para PDF',
        },
      },
      myDashboard: {
        assignedActions: {
          index: {
            errorMessage: 'Error al cargar las acciones asignadas. Por favor, inténtelo de nuevo.',
          },
        },
        kpi: {
          title: 'Indicadores clave de rendimiento',
          filters: 'Filtros',
          myData: 'Mis datos',
          companyData: 'Datos de la empresa',
          financialTitle: 'Ahorro de costos',
          leaksTitle: 'Estadísticas de eventos',
          energyTitle: 'Ahorro de energía',
          totalIdentified: 'Total Identificado',
          repaired: 'Reparado',
          unrepaired: 'Sin Reparar',
          ofTotal: 'del total',
          myStanding: 'Mi Posición',
          gaugeTooltipLeaks: 'Compara tu recuento de fugas con otros usuarios que han registrado fugas en el rango de fechas seleccionado. La barra va del menor al mayor recuento.',
          gaugeTooltipEnergy: 'Compara tu ahorro de energía con otros usuarios que han registrado fugas en el rango de fechas seleccionado. La barra va del menor al mayor valor en kWh.',
          gaugeTooltipCost: 'Compara tu costo con otros usuarios que han registrado fugas en el rango de fechas seleccionado. Los resultados se agrupan por moneda.',
          tooltipCostTotal: 'El valor total de la posible reducción de costos que has identificado. Las clasificaciones incluyen a todos los usuarios de tu empresa que han identificado reducción de costos.',
          tooltipCostRepaired: 'La porción de tu reducción de costos identificada que ha sido resuelta.',
          tooltipCostUnrepaired: 'La porción de tu reducción de costos identificada que permanece sin resolver.',
          tooltipLeaksTotal: 'El número total de registros de fugas que has creado y subido a la plataforma. Las clasificaciones incluyen a todos los usuarios de tu empresa que han subido al menos un registro.',
          tooltipLeaksRepaired: 'La porción de tus registros que han sido resueltos.',
          tooltipLeaksUnrepaired: 'La porción de tus registros que permanecen sin resolver.',
          tooltipEnergyTotal: 'El valor total del posible ahorro de energía que has identificado. Las clasificaciones incluyen a todos los usuarios de tu empresa que han identificado ahorro de energía.',
          tooltipEnergyRepaired: 'La porción de tu ahorro de energía identificado que ha sido resuelta.',
          tooltipEnergyUnrepaired: 'La porción de tu ahorro de energía identificado que permanece sin resolver.',
          gaugeLowest: 'Más bajo',
          gaugeHighest: 'Más alto',
          noData: 'No hay datos disponibles para los filtros seleccionados.',
          apply: 'Aplicar',
          cancel: 'Cancelar',
          changeDates: 'Cambiar fechas',
          loading: 'Cargando...',
          selectDateRange: 'Seleccione un rango de fechas',
          selectDateRangeDescription: 'Elija un rango de fechas y haga clic en Aplicar para ver sus KPI.',
          datePresets: {
            label: 'Preselecciones de fecha',
            today: 'Hoy',
            yesterday: 'Ayer',
            last7Days: 'Últimos 7 días',
            last30Days: 'Últimos 30 días',
            thisWeek: 'Esta semana',
            lastWeek: 'Semana pasada',
            thisMonth: 'Este mes',
            lastMonth: 'Mes pasado',
            thisYear: 'Este año',
            lastYear: 'Año pasado',
            allTime: 'Todo el tiempo',
          },
          calendar: {
            weekDays: {
              mon: 'Lu',
              tue: 'Ma',
              wed: 'Mi',
              thu: 'Ju',
              fri: 'Vi',
              sat: 'Sá',
              sun: 'Do',
            },
            months: {
              january: 'Enero',
              february: 'Febrero',
              march: 'Marzo',
              april: 'Abril',
              may: 'Mayo',
              june: 'Junio',
              july: 'Julio',
              august: 'Agosto',
              september: 'Septiembre',
              october: 'Octubre',
              november: 'Noviembre',
              december: 'Diciembre',
            },
          },
        },
        charts: {
          charts: {
            errorMessages: {
              errorMessageOne: 'Error al cargar los registros de fugas. Por favor, inténtelo de nuevo.',
            },
          },
        },
        index: {
          assignedActions: 'Acciones asignadas a usted',
        },
      },
      export: {
        imageUrl: 'URL de imagen del registro {{number}}',
        additionalImageUrl: 'URL de imagen adicional de fuga {{number}}',
        audioFileUrlOne: 'URL de archivo de audio',
        smartTag: 'Etiqueta inteligente',
        workRef: 'Referencia de trabajo',
        per: 'por ',
      },
      downloadApk: {
        pageTitle: 'PROSARIS - Descargar aplicación',
        title: 'Descargar la aplicación PROSARIS',
        mobileInstructions:
          'Si estás viendo esta página en una tableta o dispositivo móvil, toca el botón "Descargar" a continuación para descargar la aplicación PROSARIS en tu dispositivo.',
        desktopInstructions:
          'Si estás viendo esta página en una computadora, escanea el código QR con tu tableta o dispositivo móvil y descarga la aplicación desde allí.',
        downloadButton: 'Descargar',
        qrCodeLabel: 'Descargar aplicación PROSARIS',
        additionalInstructions: {
          title: 'Instrucciones adicionales de descarga',
          description:
            'Estás descargando un APK (Android Package Kit) desde un sitio web y podrías encontrar medidas de seguridad adicionales en comparación con descargar una aplicación desde Google Play.',
          step1: 'Puede aparecer una advertencia que diga "Este archivo podría ser dañino". Asegúrate de tocar "Descargar de todos modos".',
          step2:
            'Es posible que tu dispositivo indique que "no está permitido instalar aplicaciones desconocidas desde esta fuente". Se te pedirá abrir la configuración de tu dispositivo.',
          step3:
            'En la página de configuración a la que te dirigen, activa el interruptor para permitir descargas de aplicaciones desconocidas.',
          step4:
            'Es posible que se te pida "Escanear aplicación" como medida de seguridad final. Después del escaneo, se te pedirá descargar la aplicación.',
        },
      },
    },
    languages: {
      English: 'Inglés',
      Chinese: 'Chino',
      Spanish: 'Español',
      French: 'Francés',
      German: 'Alemán',
      Norwegian: 'Noruego',
      Italian: 'Italiano',
      Turkish: 'Turco',
      Japanese: 'Japonés',
      Portuguese: 'Portugués',
      Korean: 'Koreano',
    },
  },
};
